/* This file was auto-generated using @smartdevis/server/bin/downloadTranslation.ts */

import { Domain } from "@smartdevis/server/src/domain"

export const translationsTs = 1666254433970

export const translations: Domain.Translations = {
    "$1 - Round 2": { de: "Abgebotsrunde", en: "Request second offer", updatedTs: 1651155609097 },
    "$1 ascending": { de: "$1 aufsteigend", en: "$1 ascending", updatedTs: 1651155609097 },
    "$1 descending": { de: "$1 absteigend", en: "$1 descending", updatedTs: 1651155609097 },
    "$1 devis": { de: "$1 Ausschreibungen", en: "$1 tender", updatedTs: 1651155609097 },
    "$1 has cancelled this offer request. Thank you very much for your efforts": {
        de: "$1 hat diese Angebotsanfrage storniert. Besten Dank für Ihre Bemühungen.",
        en: "$1 has cancelled this offer request. Thank you very much for your efforts.",
        updatedTs: 1651155609097
    },
    "$1 has gone to the negotiations phase, where he has the possibility to update the positions and deductions again.":
        {
            de: "$1 hat Vergabeverhandlungen gestartet, in der er das Leistungsverzeichnis und Abzüge nochmals überarbeiten kann.",
            en: "$1 has gone to the negotiations phase, where he has the possibility to update work description and deductions again.",
            updatedTs: 1651155609097
        },
    "$1 in this devis": { de: "$1 in dieser Ausschreibung", en: "$1 in this tender", updatedTs: 1651155609097 },
    "$1 in this project": { de: "$1 in diesem Projekt", en: "$1 in this project", updatedTs: 1651155609097 },
    ".01s and .crbx": { de: ".01s und .crbx", en: ".01s and .crbx", updatedTs: 1651155609097 },
    Abbreviation: { de: "Kürzel", en: "Abbreviation", updatedTs: 1651155609097 },
    Accept: { de: "Akzeptieren", en: "Accept", updatedTs: 1651155609097 },
    "Accept offer": { de: "Offerte akzeptieren", en: "Accept offer", updatedTs: 1651155609097 },
    "Access denied": { de: "Zugang verweigert", en: "Access denied", updatedTs: 1651155609097 },
    "Acknowledged!": { de: "Verstanden!", en: "Acknowledged!", updatedTs: 1651155609097 },
    Active: { de: "Aktiv", en: "Active", updatedTs: 1651155609097 },
    Activity: { de: "Aktivität", en: "Activity", updatedTs: 1651155609097 },
    Add: { de: "Hinzufügen", en: "Add", updatedTs: 1651155609097 },
    "Add $1": { de: "Hinzufügen", en: "Add $1", updatedTs: 1651155609097 },
    "Add contact": { de: "Unternehmer hinzufügen", en: "Add contact", updatedTs: 1651155609097 },
    "Add contractor": { de: "Neuer Submittent", en: "Add contractor", updatedTs: 1651155609097 },
    "Add deduction": { de: "Neuer Abzug", en: "Add deduction", updatedTs: 1651155609097 },
    "Add devis template": { de: "LV Vorlage erstellen", en: "Add work description template", updatedTs: 1651155609097 },
    "Add new project": { de: "Neues Projekt erstellen", en: "Add new project", updatedTs: 1651155609097 },
    "Add sub-total": { de: "Zwischensumme hinzufügen", en: "Add sub-total", updatedTs: 1651155609097 },
    "Add to submitters": { de: "Zu Unternehmern hinzufügen", en: "Add to submitters", updatedTs: 1651155609097 },
    Added: { de: "Hinzugefügt", en: "Added", updatedTs: 1651155609097 },
    "Additional fileds": { de: "Zusätzliche Felder", en: "Additional fields", updatedTs: 1651155609097 },
    "Additional information": {
        de: "Zusätzliche Informationen",
        en: "Additional information",
        updatedTs: 1651155609097
    },
    Address: { de: "Adresse", en: "Address", updatedTs: 1651155609097 },
    "Adjusted prices sent to $1": {
        de: "Angepasste Preise an $1 gesendet",
        en: "Adjusted prices sent to $1",
        updatedTs: 1651155609097
    },
    "Admin Dashboard": { de: "Admin Dashboard", en: "Admin Dashboard", updatedTs: 1651155609097 },
    "Admin Panel": { de: "Admin Panel", en: "Admin Panel", updatedTs: 1651155609097 },
    "Are you sure you want to delete this contact?": {
        de: "Willst du diesen Kontakt wirklich löschen?",
        en: "Are you sure you want to delete this template?",
        updatedTs: 1658735497314
    },
    '$1 invites you to submit an offer for the second round. Click on "Submit 2nd Round Offer" to enter your conditions.':
        {
            de: "$1 bittet dich um ein Abgebot. Klicke auf “Abgebot einreichen”, um deine Konditionen einzugeben.",
            en: '$1 invites you to submit an offer for the second round. Click on "Submit 2nd Round Offer" to enter your conditions.',
            updatedTs: 1658735130231
        },
    "$1 would like to ask you for an offer.": {
        de: "$1 bittet dich um eine Offerte.",
        en: "$1 would like to ask you for an offer.",
        updatedTs: 1658735135156
    },
    "Add contacts if you wish to select submitters": {
        de: "Füge Kontakte hinzu um Unternehmer auswählen zu können.",
        en: "Add contacts if you wish to select submitters",
        updatedTs: 1658735140255
    },
    All: { de: "Alle", en: "All", updatedTs: 1651155609097 },
    "All Projects": { de: "Alle Projekte", en: "All projects", updatedTs: 1651155609097 },
    "All changelogs (change app language in order to view other languages):": {
        de: "Alle Änderungsprotokolle:",
        en: "All changelogs:",
        updatedTs: 1651155609097
    },
    "All data in fields will be lost.": {
        de: "Alle ausgefüllten Daten gehen verloren.",
        en: "All data in fields will be lost.",
        updatedTs: 1651155609097
    },
    "All devis created, inserted or uploaded to the project will be listed here": {
        de: "Alle erstellten, eingefügten oder hochgeladenen Leistungsverzeichnisse in diesem Projekt werden hier aufgeführt.",
        en: "All work descriptions created, inserted or uploaded to the project will be listed here",
        updatedTs: 1651155609097
    },
    "All devis data will be lost.": {
        de: "Alle Daten zum Leistungsverzeichnis gehen verloren.",
        en: "All work description data will be lost.",
        updatedTs: 1651155609097
    },
    "All offers": { de: "Alle Offerten", en: "All offers", updatedTs: 1651155609097 },
    "All offers rejected": { de: "Alle Anfragen abgelehnt", en: "All offers rejected", updatedTs: 1651155609097 },
    "All project details, estimates, devis and positions will be copied to new project.": {
        de: "Alle Projektdetails, Offerten und Ausschreibungen werden ins neue Projekt kopiert.",
        en: "All project details, offers and tenders will be copied to new project.",
        updatedTs: 1651155609097
    },
    "All project details, estimates, devis and positions will be copied to template.": {
        de: "Alle Projektdetails, Offerten und Ausschreibungen werden ins neue Projekt kopiert.",
        en: "All project details, offers and tenders will be copied to new project.",
        updatedTs: 1651155609097
    },
    "All projects": { de: "Alle Projekte", en: "All projects ", updatedTs: 1651155609097 },
    Amount: { de: "Menge", en: "Amount", updatedTs: 1651155609097 },
    Angebot: { de: "Angebot", en: "Offer", updatedTs: 1651155609097 },
    "Approval requested": { de: "Bestätigung angefragt", en: "Approval requested", updatedTs: 1651155609097 },
    Architect: { de: "Architekt", en: "Architect", updatedTs: 1651155609097 },
    "Architect details:": { de: "Details des Architekten:", en: "Architect details:", updatedTs: 1651155609097 },
    "Architect initial round devis": {
        de: "LV vom Architekten hochgeladen (Angebotsrunde)",
        en: "Architect initial round work description",
        updatedTs: 1651155609097
    },
    "Architect negotiations round devis": {
        de: "LV vom Architekten hochgeladen (Abgebotsrunde)",
        en: "Architect negotiations round work description",
        updatedTs: 1651155609097
    },
    Archived: { de: "Archiviert", en: "Archived", updatedTs: 1651155609097 },
    "Are you sure you want to create template?": {
        de: "Bist du sicher dass du eine Vorlage erstellen möchtest?",
        en: "Are you sure you want to create a new template?",
        updatedTs: 1658735166600
    },
    "Are you sure you want to delete devis?": {
        de: "Bist du sicher, dass du das Leistungsverzeichnis löschen möchtest?",
        en: "Are you sure you want to delete work description?",
        updatedTs: 1658735236537
    },
    "Are you sure you want to delete project?": {
        de: "Bist du sicher, dass du das Projekt löschen möchtest?",
        en: "Are you sure you want to delete project?",
        updatedTs: 1658735468675
    },
    "Are you sure you want to delete template?": {
        de: "Bist du sicher, dass du die Vorlage löschen möchtest?",
        en: "Are you sure you want to delete template?",
        updatedTs: 1658735518528
    },
    "All devis preview": { de: "Vorschau aller Ausschreibungen", en: "All Tenders preview", updatedTs: 1666352524446 },
    "Contract created $1": { de: "Werkvertrag generiert", en: "Contract created", updatedTs: 1651155609097 },
    "Are you sure you want to delete this partner?": {
        de: "Willst du diesen Partner wirklich entfernen?",
        en: "Are you sure you want to delete this partner?",
        updatedTs: 1658735501643
    },
    "Are you sure you want to delete this template?": {
        de: "Willst du diese Vorlage wirklich löschen?",
        en: "Are you sure you want to delete this template?",
        updatedTs: 1658735505559
    },
    "Are you sure you want to proceed?": {
        de: "Willst du wirklich fortfahren?",
        en: "Are you sure you want to proceed?",
        updatedTs: 1658735533803
    },
    "Are you sure you want to reject offer?": {
        de: "Bist du sicher, dass du die Offerte ablehnen möchtest?",
        en: "Are you sure you want to reject offer?",
        updatedTs: 1658735540809
    },
    "Are you sure you want to remove that form?": {
        de: "Bist du sicher, dass du dieses Formular entfernen willst?",
        en: "Are you sure you want to remove that form?",
        updatedTs: 1658735554769
    },
    "At unit prices": { de: "Zu Einheitspreisen", en: "At unit prices", updatedTs: 1651155609097 },
    "Attach.": { de: "Anhänge", en: "Attach.", updatedTs: 1651155609097 },
    "Attach.{attachments on positions view}": { de: "Anhänge", en: "Attach.", updatedTs: 1651155609097 },
    "Attachment, e.g protocol or final document:": {
        de: "Anhänge hochladen, z.B. ein Vergabeprotokoll:",
        en: "Attachment, e.g. protocol or final document:",
        updatedTs: 1651155609097
    },
    Attachments: { de: "Anhänge", en: "Attachments", updatedTs: 1651155609097 },
    "Attachments Upload": { de: "Anhänge hochladen", en: "Attachments Upload", updatedTs: 1651155609097 },
    Back: { de: "Zurück", en: "Back", updatedTs: 1651155609097 },
    Bauabzug: { de: "Bauabzug", en: "Construction allowance", updatedTs: 1651155609097 },
    Bauabzüge: { de: "Bauabzüge", en: "Construction allowances", updatedTs: 1651155609097 },
    "Before the contract is created, the contractor must approve the price adjustments you made.": {
        de: "Sobald die Preise vom Unternehmer akzeptiert werden, wird ein Werkvertrag generiert.",
        en: "Before the contract is created, the contractor must approve the price adjustments you made.",
        updatedTs: 1651155609097
    },
    "Billing address": { de: "Rechnungsadresse", en: "Billing address", updatedTs: 1651155609097 },
    CHF: { de: "CHF", en: "CHF", updatedTs: 1651155609097 },
    Cancel: { de: "Abbrechen", en: "Cancel ", updatedTs: 1651155609097 },
    "Cancelled by architect": {
        de: "Abgelehnt vom Architekten",
        en: "Cancelled by architect",
        updatedTs: 1651155609097
    },
    "Cannot be empty": { de: "Darf nicht leer sein.", en: "Cannot be empty.", updatedTs: 1651155609097 },
    "Cannot create round from non submitted offer": {
        de: "Runde kann nicht aus nicht eingereichtem Angebot erstellt werden.",
        en: "Cannot create round from non submitted offer",
        updatedTs: 1651155609097
    },
    Categories: { de: "Kategorien", en: "Categories", updatedTs: 1651155609097 },
    "Change logo": { de: "Logo ändern", en: "Change logo", updatedTs: 1651155609097 },
    Changelog: { de: "Änderungsprotokoll", en: "Changelog", updatedTs: 1651155609097 },
    "Changelog editor": { de: "Änderungsprotokoll Editor", en: "Changelog editor", updatedTs: 1651155609097 },
    "Check contract proposal": {
        de: "Vertragsvorschlag prüfen",
        en: "Check contract proposal",
        updatedTs: 1651155609097
    },
    City: { de: "Ort", en: "City", updatedTs: 1651155609097 },
    "Clear all values": { de: "Alle Werte löschen", en: "Clear all values", updatedTs: 1651155609097 },
    Client: { de: "Bauherrschaft", en: "Client", updatedTs: 1651155609097 },
    "Choose client's representative contact information source": {
        de: "Wähle aus, wer als Bauherrenvertretung aufgeführt werden soll.",
        en: "Choose client's representative contact information source",
        updatedTs: 1658735573375
    },
    "Choose project for the duplicated devis": {
        de: "Wähle das Projekt, in welches die Ausschreibung kopiert werden soll.",
        en: "Choose a project for the duplicated tender.",
        updatedTs: 1658735582820
    },
    "Client’s representative": { de: "Bauherrenvertreter", en: "Client's representative", updatedTs: 1651155609097 },
    Close: { de: "Schliessen", en: "Close", updatedTs: 1651155609097 },
    Comment: { de: "Kommentar", en: "Comment", updatedTs: 1651155609097 },
    "Comment to the offer created by $1": {
        de: "Kommentar zum erstellten Angebot von $1",
        en: "Comment to the offer created by $1",
        updatedTs: 1651155609097
    },
    Comments: { de: "Kommentare", en: "Comments", updatedTs: 1651155609097 },
    "Company Details": { de: "Firmendetails", en: "Company Details", updatedTs: 1651155609097 },
    Comparison: { de: "Vergleich", en: "Comparison", updatedTs: 1651155609097 },
    Conditions: { de: "Bedingungen", en: "Conditions", updatedTs: 1651155609097 },
    Confirm: { de: "Bestätigen", en: "Confirm", updatedTs: 1651155609097 },
    "Confirm contacts import": {
        de: "Kontaktimport bestätigen",
        en: "Confirm contacts import",
        updatedTs: 1651155609097
    },
    "Congratulations! The submission is closed. $1 will contact you directly.": {
        de: "Herzliche Gratulation! Die Ausschreibung ist abgeschlossen. $1 wird sich direkt mit Ihnen in Verbindung setzen.",
        en: "Congratulations! The submission is closed. $1 will contact you directly.",
        updatedTs: 1651155609097
    },
    "Connecting an offer": { de: "Angebot verbinden", en: "Connecting an offer", updatedTs: 1651155609097 },
    "Construction management": { de: "Baumanagement", en: "Construction management", updatedTs: 1651155609097 },
    "Construction object": { de: "Bauobjekt", en: "Construction object", updatedTs: 1651155609097 },
    Contact: { de: "Kontakt", en: "Contact", updatedTs: 1651155609097 },
    "Contact details": { de: "Kontaktdetails", en: "Contact details", updatedTs: 1651155609097 },
    Contacts: { de: "Kontakte", en: "Contacts", updatedTs: 1651155609097 },
    Content: { de: "Inhalt", en: "Content", updatedTs: 1651155609097 },
    Contract: { de: "Werkvertrag", en: "Contract", updatedTs: 1651155609097 },
    "Contract created": { de: "Vertrag erstellt", en: "Contract created", updatedTs: 1651155609097 },
    "Contract preview": { de: "Vorschau des Werkvertrages:", en: "Contract preview", updatedTs: 1651155609097 },
    "Contract preview:": { de: "Vorschau des Werkvertrages:", en: "Contract preview:", updatedTs: 1651155609097 },
    Contractor: { de: "Unternehmer", en: "Contractor", updatedTs: 1651155609097 },
    "Contractor attachments": { de: "Anhänge vom Unternehmer", en: "Contractor attachments", updatedTs: 1651155609097 },
    "Contractor attachments to the offer created by $1": {
        de: "Anhänge zur Offerte vom Unternehmer $1",
        en: "Contractor attachments to the offer created by $1",
        updatedTs: 1651155609097
    },
    "Contractor fills": { de: "Unternehmer füllt aus", en: "Contractor fills", updatedTs: 1651155609097 },
    "Contractor offer proposals": {
        de: "Angebot des Unternehmers",
        en: "Contractor offer proposal",
        updatedTs: 1651155609097
    },
    "Contractor recommendation": { de: "Vergabeantrag", en: "Contractor recommendation", updatedTs: 1651155609097 },
    "Company Name": { de: "Firma", en: "Company Name", updatedTs: 1655383042994 },
    "Contractor name": { de: "Unternehmer Name", en: "Contractor Name", updatedTs: 1655383004431 },
    "Conditions, positions and deductions can be:": {
        de: "Du hast folgende Möglichkeiten im Leistungsverzeichnis und bei den Abzügen:",
        en: "Conditions, work description and deductions can be:",
        updatedTs: 1658735604805
    },
    "Company name": { de: "Firma", en: "Company Name", updatedTs: 1655383045826 },
    "Contract prepared, you can view it in the finalization step": {
        de: "Der Vertrag ist vorbereitet, du kannst ihn im abschliessenden Schritt ansehen.",
        en: "Contract prepared, you can view it in the finalization step",
        updatedTs: 1658735611474
    },
    "Contractors invited": { de: "Unternehmer eingeladen", en: "Contractors invited", updatedTs: 1651155609097 },
    "Convert to PER position": {
        de: "Umwandeln zu Per-Position",
        en: "Convert to Per position",
        updatedTs: 1651155609097
    },
    "Convert to basic position": {
        de: "Umwandeln zu Basisposition",
        en: "Convert to basic position",
        updatedTs: 1651155609097
    },
    "Copied!": { de: "Kopiert!", en: "Copied!", updatedTs: 1651155609097 },
    Copies: { de: "Übersetzungen", en: "Copies", updatedTs: 1651155609097 },
    "Copy $1": { de: "Kopiere $1", en: "Copy $1", updatedTs: 1651155609097 },
    "Copy details": { de: "Kopiere Details", en: "Copy details", updatedTs: 1651155609097 },
    "Copy to current": { de: "Duplizieren", en: "Duplicate", updatedTs: 1651155609097 },
    "Cost estimate (original)": {
        de: "Kostenvoranschlag original",
        en: "Const estimate (original)",
        updatedTs: 1651155609097
    },
    "Cost estimate (revised)": {
        de: "Kostenvoranschlag revidiert",
        en: "Const estimate (revised)",
        updatedTs: 1651155609097
    },
    "Cost estimate VAT": { de: "Kostenvoranschlag", en: "Cost estimate VAT", updatedTs: 1651155609097 },
    "Could not detect any valid contacts.": {
        de: "Es konnten keine gültigen Kontaktdaten erkannt werden.",
        en: "Could not detect any valid contacts.",
        updatedTs: 1651155609097
    },
    Country: { de: "Land", en: "Country", updatedTs: 1651155609097 },
    Create: { de: "Erstellen ", en: "Create", updatedTs: 1651155609097 },
    "Create from custom template": {
        de: "Aus eigener Vorlage",
        en: "Create from custom template",
        updatedTs: 1651155609097
    },
    "Create from template": { de: "Aus Demovorlage", en: "Create from template", updatedTs: 1651155609097 },
    "Create new": { de: "Neues Projekt", en: "Project", updatedTs: 1651155609097 },
    "Create partner": { de: "Partner erstellen", en: "Create Partner", updatedTs: 1651155609097 },
    "Create project": { de: "Neues Projekt", en: "Create project", updatedTs: 1651155609097 },
    "Create project {submit button}": { de: "Projekt erstellen", en: "Create project", updatedTs: 1651155609097 },
    "Create template": { de: "Vorlage erstellen", en: "Create template", updatedTs: 1651155609097 },
    "Create Tender": { de: "Ausschreibung erstellen", en: "Create Tender", updatedTs: 1666352387012 },
    "Create template {submit button}": {
        de: "Vorlage erstellen",
        en: "Create template {submit button}",
        updatedTs: 1651155609097
    },
    Created: { de: "Erstellt", en: "Created", updatedTs: 1651155609097 },
    "Creation date": { de: "Erstelldatum", en: "Creation date", updatedTs: 1651155609097 },
    "Postal Code": { de: "PLZ", en: "Postal Code", updatedTs: 1651155609098 },
    "Current round attachments": {
        de: "Anhänge der aktuellen Runde",
        en: "Current round attachments",
        updatedTs: 1651155609097
    },
    DE: { de: "DE", en: "DE", updatedTs: 1651155609097 },
    Dashboard: { de: "Dashboard", en: "Dashboard", updatedTs: 1651155609097 },
    Deduction: { de: "Abzug", en: "Deduction", updatedTs: 1651155609097 },
    Deductions: { de: "Abzüge", en: "Deductions", updatedTs: 1651155609097 },
    Delete: { de: "Entfernen ", en: "Delete", updatedTs: 1651155609097 },
    "Desciption/subtitle": { de: "Beschreibung/Untertitel", en: "Desciption/subtitle", updatedTs: 1651155609097 },
    Description: { de: "Beschreibung", en: "Description", updatedTs: 1651155609097 },
    "Details / Compare (Max 3)": {
        de: "Details / Vergleich (max. 3)",
        en: "Details / Compare (max. 3)",
        updatedTs: 1651155609097
    },
    "Detected duplicate contacts.": {
        de: "Doppelte Kontakte erkannt",
        en: "Detected duplicate contacts",
        updatedTs: 1651155609097
    },
    "Devis Templates": { de: "LV-Vorlagen", en: "Work description templates", updatedTs: 1651155609097 },
    "Devis number": { de: "Nummer", en: "Nummer", updatedTs: 1651155609097 },
    "Devis template": { de: "LV-Vorlage", en: "Work description template", updatedTs: 1651155609097 },
    Discount: { de: "Rabatt", en: "Discount", updatedTs: 1651155609097 },
    Discounts: { de: "Rabatte", en: "Discounts", updatedTs: 1651155609097 },
    "Documents upload": { de: "Dokumentenupload", en: "Documents upload", updatedTs: 1651155609097 },
    Download: { de: "Download", en: "Download", updatedTs: 1651155609097 },
    "Download contacts template": {
        de: "Vorlage für Kontaktimport",
        en: "Download contacts template",
        updatedTs: 1651155609097
    },
    "Download contract": { de: "Werkvertrag herunterladen", en: "Download contract\n", updatedTs: 1651155609097 },
    "Draft, not to be used": { de: "Muster ", en: "Draft, not to be used", updatedTs: 1651155609097 },
    Duplicate: { de: "Duplizieren", en: "Duplicate", updatedTs: 1651155609097 },
    "Duplicate devis": {
        de: "Leistungsverzeichnis duplizieren",
        en: "Duplicate work description",
        updatedTs: 1651155609097
    },
    Duplicated: { de: "Dupliziert", en: "Duplicated", updatedTs: 1651155609097 },
    EN: { de: "EN", en: "EN", updatedTs: 1651155609097 },
    "Early payment discount": { de: "Skonto", en: "Early payment discount", updatedTs: 1651155609097 },
    "Early payment discounts": { de: "Skonto", en: "Early payment discounts", updatedTs: 1651155609097 },
    Edit: { de: "Bearbeiten", en: "Edit", updatedTs: 1651155609097 },
    "Edit account": { de: "Konto bearbeiten", en: "Edit account", updatedTs: 1651155609098 },
    "Edit project": { de: "Projekt bearbeiten", en: "Edit project", updatedTs: 1651155609098 },
    Edited: { de: "Bearbeitet", en: "Edited", updatedTs: 1651155609098 },
    Email: { de: "E-Mail Adresse", en: "E-Mail", updatedTs: 1651155609098 },
    "Email address": { de: "E-Mail Adresse", en: "Email address", updatedTs: 1651155609098 },
    "Empty List": { de: "Leere Liste", en: "Empty list", updatedTs: 1651155609098 },
    "Enter $1": { de: "$1 eingeben", en: "Enter $1", updatedTs: 1651155609098 },
    "Enter $1. Press Shift + Enter for newline": {
        de: "$1 einfügen. Shift + Eingabe für eine neue Zeile.",
        en: "Enter $1. Press Shift + Enter for newline",
        updatedTs: 1651155609098
    },
    "Enter unit": { de: "Einheit eingeben", en: "Enter unit", updatedTs: 1651155609098 },
    "Entry date": { de: "Eingabedatum", en: "Entry date", updatedTs: 1651155609098 },
    "Entry date:": { de: "Eingabedatum:", en: "Entry date:", updatedTs: 1651155609098 },
    Error: { de: "Fehler", en: "Error", updatedTs: 1651155609098 },
    Errors: { de: "Fehler entdeckt", en: "Errors", updatedTs: 1651155609098 },
    "Devis overview": { de: "Übersicht der Ausschreibungen", en: "Tenders overview", updatedTs: 1666352583637 },
    "Excl. VAT": { de: "exkl. MwSt.", en: "Excl. VAT", updatedTs: 1651155609098 },
    "Exclude VAT": { de: "exkl. MwSt.", en: "Exclude VAT", updatedTs: 1651155609098 },
    Export: { de: "Export (PDF)", en: "Export (PDF)", updatedTs: 1651155609098 },
    "Export comparison": { de: "Angebotsvergleich (PDF)", en: "Export comparison (PDF)", updatedTs: 1651155609098 },
    "Export offer": { de: "Export Offerte (PDF)", en: "Export offer (PDF)", updatedTs: 1651155609098 },
    "Export preview": { de: "Vorschau (PDF)", en: "Export preview", updatedTs: 1651155609098 },
    "Export project submitters": {
        de: "Submittenten des Projekts exportieren",
        en: "Export project submitters",
        updatedTs: 1651155609098
    },
    "Export recommendation": { de: "Export Vergabeantrag", en: "Export recommendation", updatedTs: 1651155609098 },
    "Export to PDF": { de: "Export (PDF)", en: "Export (PDF)", updatedTs: 1651155609098 },
    File: { de: "Datei", en: "File", updatedTs: 1651155609098 },
    "File name": { de: "Dateiname", en: "File name", updatedTs: 1651155609098 },
    "File size is too big": { de: "Datei zu gross", en: "File size is too big", updatedTs: 1651155609098 },
    "Filled by": { de: "Ausgefüllt durch", en: "Filled by", updatedTs: 1651155609098 },
    "Filled out by": { de: "Ausgefüllt durch", en: "Filled out by", updatedTs: 1651155609098 },
    Filler: { de: "Wird ausgefüllt durch", en: "Filler", updatedTs: 1651155609098 },
    "Final attachments": { de: "Letzte Anhänge", en: "Final attachments", updatedTs: 1651155609098 },
    "Drop your files here or select multiple documents": {
        de: "Platziere hier deine Dateien oder wähle mehrere Dokumente aus.",
        en: "Drop your files here or select multiple documents",
        updatedTs: 1658735683111
    },
    "File based devis require price to be provided manually": {
        de: "Bei dateibasierten Ausschreibungen muss der Gesamtpreis (brutto) manuell eingefügt werden",
        en: "File based work descriptions require gross price to be provided manually",
        updatedTs: 1658735688945
    },
    "Final prices are in review $1": {
        de: "Finale Preise werden geprüft",
        en: "Final prices are in review $1",
        updatedTs: 1651155609098
    },
    "Final round created": { de: "Finale Runde wurde gestartet", en: "Final round created", updatedTs: 1651155609098 },
    Finalization: { de: "Vergabe", en: "Finalization", updatedTs: 1651155609098 },
    "First name": { de: "Vorname", en: "First name", updatedTs: 1651155609098 },
    "First round comment": { de: "Kommentar Angebotsrunde", en: "First round comment", updatedTs: 1651155609098 },
    "First round offer attachments": {
        de: "Anhänge Angebotsrunde",
        en: "First round offer attachments",
        updatedTs: 1651155609098
    },
    "First round offer proposal": { de: "Offertanfrage", en: "First round offer proposal", updatedTs: 1651155609098 },
    "Flat rate": { de: "Pauschal", en: "Flat rate", updatedTs: 1651155609098 },
    "Flat-rate or at unit prices?": {
        de: "Pauschal oder Einheitspreis?",
        en: "Flat-rate or at unit price?",
        updatedTs: 1651155609098
    },
    "For a total price (Net + tax) of:": {
        de: "Für einen Gesamtpreis (Netto inkl. MwSt.) von:",
        en: "For a total price (Net incl. VAT) of:",
        updatedTs: 1651155609098
    },
    "Forbidden extensions": { de: "Nicht zugelassene Formate", en: "Forbidden extensions", updatedTs: 1651155609098 },
    "Free Text": { de: "Freitext", en: "Free text", updatedTs: 1651155609098 },
    General: { de: "Allgemeines", en: "General", updatedTs: 1651155609098 },
    "General attachments": { de: "Allgemeine Anhänge", en: "General attachments", updatedTs: 1651155609098 },
    "General information": { de: "Bedingungen", en: "Conditions", updatedTs: 1651155609098 },
    "General offer comments": {
        de: "Allgemeine Kommentare zur Offerte",
        en: "General offer comments",
        updatedTs: 1651155609098
    },
    "Generate activity": { de: "Aktivität erzeugen", en: "Generate activity", updatedTs: 1651155609098 },
    "Go back to offers": { de: "Zurück zu Offerten", en: "Go back to offers", updatedTs: 1651155609098 },
    "Got it": { de: "Weiter", en: "Got it", updatedTs: 1651155609098 },
    Gross: { de: "Brutto", en: "Gross", updatedTs: 1651155609098 },
    "Gross price": { de: "Brutto", en: "Gross price", updatedTs: 1651155609098 },
    Groups: { de: "Gruppen", en: "Groups", updatedTs: 1651155609098 },
    "I confirm that I want to cancel an offer request": {
        de: "Ich bestätige, dass ich eine Angebotsanfrage ablehnen möchte.",
        en: "I confirm that I want to cancel an offer request",
        updatedTs: 1651155609098
    },
    "I confirm that I want to invite these contractors": {
        de: "Ich bestätige, dass ich diese Unternehmer einladen möchte.",
        en: "I confirm that I want to invite these contractors",
        updatedTs: 1651155609098
    },
    "I confirm that I want to send revised offer": {
        de: "Ich bestätige, dass ich ein Abgebot einholen möchte.",
        en: "I confirm that I want to send revised offer",
        updatedTs: 1651155609098
    },
    "I confirm that I want to send this to contractor for approval": {
        de: "Ich bestätige, dass ich diese Daten zur Bestätigung an den Unternehmer sende.",
        en: "I confirm that I want to send this to contractor for approval",
        updatedTs: 1651155609098
    },
    "I confirm, I want architect the change the offer": {
        de: "Ich bestätige, dass ich den Architekten die Änderungen an der Offerte vornehmen lasse.",
        en: "I confirm, I want architect the change the offer",
        updatedTs: 1651155609098
    },
    "I confirm, I want to accept architect's offer": {
        de: "Ich bestätige, dass ich die Anpassungen des Architekten annehme.",
        en: "I confirm that I want to accept architect's offer",
        updatedTs: 1651155609098
    },
    "I confirm, I want to submit my offer": {
        de: "Ich bestätige, dass ich meine Offerte einreichen möchte.",
        en: "I confirm, I want to submit my offer",
        updatedTs: 1651155609098
    },
    "I confirm, I want to submit my second round offer": {
        de: "Ich bestätige, dass ich mein Abgebot einreichen möchte.",
        en: "I confirm, I want to submit my second round offer",
        updatedTs: 1651155609098
    },
    "I understand": { de: "Ich verstehe.", en: "I understand.", updatedTs: 1651155609098 },
    "I want to reject all other offers automatically when the contractor accepts the contract.": {
        de: "Ich möchte alle Offerten automatisch ablehnen, sobald der ausgewählte Unternehmer den Vertragsvorschlag akzeptiert.",
        en: "I want to reject all other offers automatically when the contractor accepts the contract.",
        updatedTs: 1651155609098
    },
    ID: { de: "ID", en: "ID", updatedTs: 1651155609098 },
    "No matching templates found": {
        de: "Keine passenden Vorlagen gefunden",
        en: "No matching templates found",
        updatedTs: 1651155609098
    },
    "No offer": { de: "Keine Offerte", en: "No offer", updatedTs: 1651155609098 },
    "Import contacts": { de: "Kontakte importieren", en: "Import contacts", updatedTs: 1651155609098 },
    "In negotiation": { de: "In Verhandlung", en: "In negotiation", updatedTs: 1651155609098 },
    "In negotiation from $1": { de: "In Verhandlung mit $1", en: "In negotiation from $1", updatedTs: 1651155609098 },
    "In second round": { de: "In der Abgebotsrunde", en: "In second round", updatedTs: 1651155609098 },
    "Incl. VAT": { de: "inkl. MwSt.", en: "Incl. VAT", updatedTs: 1651155609098 },
    "Include VAT": { de: "inkl. MwSt.", en: "Include VAT", updatedTs: 1651155609098 },
    "Initial round offer": { de: "Angebot des Unternehmers", en: "Initial round offer", updatedTs: 1651155609098 },
    "Invalid data will be ignored: ": {
        de: "Ungültige Daten werden ignoriert:",
        en: "Invalid data will be ignored:",
        updatedTs: 1651155609098
    },
    "Invalid decimal number": { de: "Ungültiger Dezimalwert", en: "Invalid decimal number", updatedTs: 1651155609098 },
    "Invalid document": { de: "Ungültiges Dokument", en: "Invalid document", updatedTs: 1651155609098 },
    "Invalid encryption key type": {
        de: "Falscher Typ (Verschlüsselungsschlüssel)",
        en: "Invalid encryption key type",
        updatedTs: 1651155609098
    },
    "Invalid hex color": { de: "ungültige HEX Farbe", en: "Invalid hex color", updatedTs: 1651155609098 },
    "Invalid object": { de: "ungültiges Objekt", en: "Invalid object", updatedTs: 1651155609098 },
    Invite: { de: "Einladen", en: "Invite", updatedTs: 1651155609098 },
    "Invite for Second Round": {
        de: "Zur Abgebotsrunde einladen",
        en: "Invite for second round",
        updatedTs: 1651155609098
    },
    "Invite selected": {
        de: "Ausgewählte Unternehmer einladen",
        en: "Invite selected contractors",
        updatedTs: 1651155609098
    },
    "New contact": { de: "Neuer Kontakt", en: "New contact", updatedTs: 1651155609098 },
    "New free text condition": {
        de: "Neue Bedingung (Freitext)",
        en: "New free text condition",
        updatedTs: 1651155609098
    },
    "New free text position": {
        de: "Neue Position (Freitext)",
        en: "New free text position",
        updatedTs: 1651155609098
    },
    "Invited contractors will recieve an email, with the link to the devis, project specification, and an optional message.":
        {
            de: "Eingeladene Unternehmer erhalten eine E-Mail mit einem Link zum Leistungsverzeichnis mit folgenden Zusatzinformationen: Architekturbüro, Kontakt, Telefon, E-Mail, Projekttyp, Projekt, PLZ und Ort, Arbeitsgattung, Arbeitsstart, Arbeitsende, Eingabedatum.",
            en: "Invited contractors will recieve an email, with the link to the work description, project specification, and an optional message.",
            updatedTs: 1651155609098
        },
    "Item not found": { de: "Element nicht gefunden", en: "Item not found", updatedTs: 1651155609098 },
    LE: { de: "LE", en: "LE", updatedTs: 1651155609098 },
    "Last name": { de: "Nachname", en: "Last name", updatedTs: 1651155609098 },
    "Latest action": { de: "Neueste Aktivität", en: "Latest action", updatedTs: 1651155609098 },
    "Latest action:": { de: "Neueste Aktivität", en: "Latest action:", updatedTs: 1651155609098 },
    Logout: { de: "Abmelden", en: "Logout", updatedTs: 1651155609098 },
    "No offers available": { de: "Keine Offerten verfügbar", en: "No offers available", updatedTs: 1651155609098 },
    "If you send the revised offer, conditions, positions and deductions will once again become readonly.": {
        de: "Sobald du die Einladung sendest, werden Bedingungen, Leistungsverzeichnis und Abzüge wieder nicht editierbar.",
        en: "If you send the revised offer, conditions, work description and deductions will once again become readonly.",
        updatedTs: 1658735730730
    },
    "In the meanwhile, you can try refreshing the page": {
        de: "In der Zwischenzeit kannst du versuchen, die Seite zu aktualisieren.",
        en: "In the meanwhile, you can try refreshing the page.",
        updatedTs: 1658735740696
    },
    "In this round you can upload an updated devis file": {
        de: "In dieser Runde kannst du ein überarbeitetes Leistungsverzeichnis hochladen.",
        en: "In this round you can upload an updated work description file",
        updatedTs: 1658735750510
    },
    "Later you can upload the file and have the contacts available in Smart Devis.": {
        de: "Später kannst du die Datei hochladen und hast die Kontakte in Smart Devis verfügbar.",
        en: "Later you can upload the file and have the contacts available in Smart Devis.",
        updatedTs: 1658735761588
    },
    "Leave comment in the document (optional):": {
        de: "Hinterlasse einen Kommentar im Dokument (optional):",
        en: "Leave comment in the document (optional):",
        updatedTs: 1658735768990
    },
    "Manage additional attachments": {
        de: "Zusätzliche Anhänge verwalten",
        en: "Manage additional attachments",
        updatedTs: 1651155609098
    },
    "Manage partners": { de: "Partner verwalten", en: "Manage partners", updatedTs: 1651155609098 },
    "Manage products": { de: "Produkte verwalten", en: "Manage products", updatedTs: 1651155609098 },
    "Manage submitters": { de: "Submittenten verwalten", en: "Manage submitters", updatedTs: 1651155609098 },
    "Message to contractors (optional):": {
        de: "Nachricht an Unternehmer (optional):",
        en: "Message to contractors (optional):",
        updatedTs: 1651155609098
    },
    Mt: { de: "Mt", en: "Mt", updatedTs: 1651155609098 },
    Name: { de: "Name", en: "Name", updatedTs: 1651155609098 },
    "Negotations round attachments": {
        de: "Anhänge Vergaberunde",
        en: "Negotations round attachments",
        updatedTs: 1651155609098
    },
    "Negotations round comment": {
        de: "Kommentar Abgebotsrunde",
        en: "Negotations round comment",
        updatedTs: 1651155609098
    },
    "Negotiate (Max 3)": {
        de: "Vergabeverhandlung starten (max. 3)",
        en: "Negotiate (max 3)",
        updatedTs: 1651155609098
    },
    Negotiation: { de: "Vergabeverhandlung", en: "Negotiation", updatedTs: 1651155609098 },
    "Negotiation Unit Price": {
        de: "Verhandlung Einheitspreis",
        en: "Negotiation Unit Price",
        updatedTs: 1651155609098
    },
    "Negotiation Value": { de: "Verhandlung Summe", en: "Negotiation Value", updatedTs: 1651155609098 },
    "Negotiation from $1": { de: "Verhandlung vom $1", en: "Negotiation from $1", updatedTs: 1651155609098 },
    Negotiations: { de: "Vergabeverhandlungen", en: "Negotiations", updatedTs: 1651155609098 },
    "Negotiations round offer": {
        de: "Angebot Verhandlungsrunde",
        en: "Negotiations round offer",
        updatedTs: 1651155609098
    },
    "Negotiations round offer proposal": {
        de: "Angebotsvorschlag der Verhandlungsrunde",
        en: "Negotiations round offer proposal",
        updatedTs: 1651155609098
    },
    Net: { de: "Netto", en: "Net", updatedTs: 1651155609098 },
    "Net + VAT": { de: "Netto inkl. MwSt.", en: "Net incl. VAT", updatedTs: 1651155609098 },
    "Net incl. tax": { de: "Netto inkl. MwSt.", en: "Net incl. tax", updatedTs: 1651155609098 },
    "Net price": { de: "Netto", en: "Net price", updatedTs: 1651155609098 },
    "New Devis Template Name": {
        de: "Name der LV-Vorlage",
        en: "Name of the work description template",
        updatedTs: 1651155609098
    },
    "New Freetext devis": {
        de: "Neues Freitext-LV erstellen",
        en: "New freetext work description",
        updatedTs: 1651155609098
    },
    "New PER position": { de: "Neue Per-Position", en: "New Per Position", updatedTs: 1651155609098 },
    "New Project Name": { de: "Neuer Projektname ", en: "New Project Name", updatedTs: 1651155609098 },
    "New Template Name": { de: "Neuer Name der Vorlage ", en: "New Template Name", updatedTs: 1651155609098 },
    "New additional information": {
        de: "Neue zusätzliche Informationen",
        en: "New additional information",
        updatedTs: 1651155609098
    },
    "New section title": { de: "Neuer Abschnitt", en: "New section title", updatedTs: 1651155609098 },
    "New subsection": { de: "Neuer Unterabschnitt", en: "New subsection", updatedTs: 1651155609098 },
    "New tender": { de: "Neue Ausschreibung", en: "New tender", updatedTs: 1651155609098 },
    Next: { de: "Weiter", en: "Next", updatedTs: 1651155609098 },
    "Next round created": { de: "Abgebotsrunde erstellt", en: "Next round created", updatedTs: 1651155609098 },
    "Next round requested": {
        de: "Eingeladen zur Abgebotsrunde",
        en: "Next round requested",
        updatedTs: 1651155609098
    },
    "Next round requested $1": {
        de: "Abgebotsrunde angefragt $1",
        en: "Next round requested $1",
        updatedTs: 1651155609098
    },
    "No contractor user": { de: "No contractor user", en: "No contractor user", updatedTs: 1651155609098 },
    "No data": { de: "Keine Daten vorhanden", en: "No data.", updatedTs: 1651155609098 },
    "No devis added yet": {
        de: "Es wurde noch kein Leistungsverzeichnis hinzugefügt.",
        en: "No work description added yet",
        updatedTs: 1651155609098
    },
    "No digit character present": {
        de: "Keine Zahl vorhanden",
        en: "No digit character present.",
        updatedTs: 1651155609098
    },
    "No lowercase character present": {
        de: "Keine Kleinbuchstaben vorhanden",
        en: "No lowercase character present.",
        updatedTs: 1651155609098
    },
    "Other formats": { de: "Andere Formate", en: "Other formats", updatedTs: 1651155609098 },
    "Negotiation is the last moment for changes.\nIn the negotitation, you can:\n- adjust prices provided by the contractor\n- export final offers to the pdf to share it with the client\n":
        {
            de: "Die Vergaberunde ist die letzte Möglichkeit für Änderungen.\nIn der Vergaberunde kannst du:\n- die vom Unternehmer ausgefüllten Preise anpassen\n- ein Vergabeprotokoll hochladen- den Vergabeantrag als PDF exportieren",
            en: "Negotiation is the last moment for changes.\nIn the negotitation, you can:\n- adjust prices provided by the contractor\n- export final offers to the pdf to share it with the client",
            updatedTs: 1658735822959
        },
    "New app version is available, please reload:": {
        de: "Eine neue Version ist verfügbar, bitte lade die Seite neu.",
        en: "New app version is available, please reload:\n",
        updatedTs: 1658735832121
    },
    "No request is yet in the contract phase": {
        de: "No request is yet in the contract phase",
        en: "No request is yet in the contract phase",
        updatedTs: 1651155609098
    },
    "No uppercase character present": {
        de: "Keine Grossbuchstaben vorhanden",
        en: "No uppercase character present.",
        updatedTs: 1651155609098
    },
    "Not a number type": { de: "Keine gültige Zahl", en: "Not a number type", updatedTs: 1651155609098 },
    "Not a string type": { de: "Keine gültige Eingabe", en: "Not a string type", updatedTs: 1651155609098 },
    "Not a valid email": { de: "Keine gültige E-Mail-Adresse", en: "Not a valid email", updatedTs: 1651155609098 },
    "Not an array type": { de: "Falscher Typ (Feld)", en: "Not an array type", updatedTs: 1651155609098 },
    "Not an boolean type": {
        de: "Falscher Typ (Boolescher Wert)",
        en: "Not an boolean type",
        updatedTs: 1651155609098
    },
    "Not an object type": { de: "Falscher Typ (Objekt)", en: "Not an object type", updatedTs: 1651155609098 },
    "Not fetched": { de: "Nicht geladen", en: "Not fetched", updatedTs: 1651155609098 },
    "Not found": { de: "Nicht gefunden", en: "Not found", updatedTs: 1651155609098 },
    "Not specified": { de: "Nicht spezifiziert", en: "Not specified", updatedTs: 1651155609098 },
    "Not yet invited": { de: "Noch nicht eingeladen", en: "Not yet invited", updatedTs: 1651155609098 },
    Number: { de: "Nummer", en: "Number", updatedTs: 1651155609098 },
    "Offer Request is not ready to submit": {
        de: "Offertanfrage ist nicht bereit zum versenden",
        en: "Offer Request is not ready to submit",
        updatedTs: 1651155609098
    },
    "Offer Requests": { de: "Angebotsanfragen", en: "Offer Requests", updatedTs: 1651155609098 },
    "Offer cancelled": { de: "Offerte abgelehnt", en: "Offer cancelled", updatedTs: 1651155609098 },
    "Offer comparison": { de: "Angebotsvergleich", en: "Offer comparison", updatedTs: 1651155609098 },
    "Offer connected": { de: "Offerte verbunden", en: "Offer connected", updatedTs: 1651155609098 },
    "Offer from $1": { de: "Offerte von $1", en: "Offer from $1", updatedTs: 1651155609098 },
    "Offer has already been assigned to another account": {
        de: "Das Angebot wurde bereits einem anderen Konto zugewiesen ",
        en: "Offer has already been assigned to another account",
        updatedTs: 1651155609098
    },
    "Offer is being created $1": {
        de: "Eine Offerte wird erstellt $1",
        en: "Offer is being created $1",
        updatedTs: 1651155609098
    },
    "Postal code": { de: "PLZ", en: "Postal code", updatedTs: 1651155609098 },
    Prefix: { de: "Vorspann", en: "Prefix", updatedTs: 1651155609098 },
    "Offer received $1": { de: "Offerte erhalten", en: "Offer received", updatedTs: 1651155609098 },
    "Offer requested": { de: "Offerte angefragt", en: "Offer requested", updatedTs: 1651155609098 },
    "Offer submitted": { de: "Offerte gesendet", en: "Offer submitted", updatedTs: 1651155609098 },
    Offers: { de: "Submission", en: "Offers", updatedTs: 1651155609098 },
    "Offers cancelled": { de: "Offerten abgelehnt", en: "Offers cancelled", updatedTs: 1651155609098 },
    "Offers comparison": { de: "Offertenvergleich", en: "Offers comparison", updatedTs: 1651155609098 },
    "Offers:": { de: "Offerten:", en: "Offers:", updatedTs: 1651155609098 },
    "Once contractors are invited, parts of the system like possitions, deductions, and conditions will become readonly.":
        {
            de: "Sobald Unternehmer eingeladen wurden, werden Teile des Systems wie Bedingungen, Leistungsverzeichnis und Abzüge nicht mehr editierbar.",
            en: "Once contractors are invited, parts of the system like possitions, deductions, and conditions will become readonly.",
            updatedTs: 1651155609098
        },
    "Once the second round has been initiated only selected contractors can submit offers,": {
        de: "Nach Beginn der Abgebotsrunde können nur die ausgewählten Unternehmer Abgebote einreichen.",
        en: "Once the second round has been initiated only selected contractors can submit offers.",
        updatedTs: 1651155609098
    },
    Open: { de: "Öffnen", en: "Open", updatedTs: 1651155609098 },
    "Open Devis": { de: "Ausschreibung öffnen", en: "Open Tender", updatedTs: 1651155609098 },
    "Open offer": { de: "Offerte öffnen", en: "Open offer", updatedTs: 1651155609098 },
    "Original devis": { de: "Leistungsverzeichnis", en: "Work description", updatedTs: 1651155609098 },
    Other: { de: "Andere", en: "Other", updatedTs: 1651155609098 },
    Owner: { de: "Eigentümer", en: "Owner", updatedTs: 1651155609098 },
    "Owner’s representative": { de: "Eigentümervertreter", en: "Owner's representative", updatedTs: 1651155609098 },
    "PER position": { de: "Per-Position", en: "Per position", updatedTs: 1651155609098 },
    "Page $1": { de: "Seite $1", en: "Page $1", updatedTs: 1651155609098 },
    Pauschalabzug: { de: "Pauschalabzug", en: "Flat rate deduction", updatedTs: 1651155609098 },
    Pauschalabzüge: { de: "Pauschalabzüge", en: "Flat rate deductions", updatedTs: 1651155609098 },
    "Phone Number": { de: "Telefonnummer", en: "Phone Number", updatedTs: 1651155609098 },
    "Phone number": { de: "Telefonnummer", en: "Phone number", updatedTs: 1651155609098 },
    "Planned start: $1": { de: "Datum der Realisierung: $1", en: "Planned start: $1", updatedTs: 1651155609098 },
    "Planner / Architect": { de: "Planer/Architekt", en: "Planner/Architect", updatedTs: 1651155609098 },
    "Planner/Architect": { de: "Planer/Architekt", en: "Planner/Architect", updatedTs: 1651155609098 },
    Position: { de: "Position", en: "Position", updatedTs: 1651155609098 },
    Positions: { de: "Leistungsverzeichnis", en: "Work description", updatedTs: 1651155609098 },
    "Positions and deductions can be:": {
        de: "Positionen und Abzüge wurden:",
        en: "Positions and deductions can be:",
        updatedTs: 1651155609098
    },
    Price: { de: "Betrag", en: "Price", updatedTs: 1651155609098 },
    "Printed on $1{date}": { de: "Erstellt am $1", en: "Created on $1", updatedTs: 1651155609098 },
    "Privacy Policy": { de: "Datenschutzerklärung", en: "Privacy Policy", updatedTs: 1651155609098 },
    Proceed: { de: "Fortfahren", en: "Proceed", updatedTs: 1651155609098 },
    "Product groups": { de: "Produktgruppen", en: "Product Groups", updatedTs: 1651155609098 },
    Products: { de: "Produkte", en: "Products", updatedTs: 1651155609098 },
    Project: { de: "Projekt", en: "Project", updatedTs: 1651155609098 },
    "Project Name": { de: "Projektname", en: "Project Name", updatedTs: 1651155609098 },
    "Project Number": { de: "Projektnummer", en: "Project Number", updatedTs: 1651155609098 },
    "Project Type": { de: "Projekttyp", en: "Project Type", updatedTs: 1651155609098 },
    "Project address": { de: "Projektadresse", en: "Project Address", updatedTs: 1651155609098 },
    "Project details": { de: "Projektdetails", en: "Project details", updatedTs: 1651155609098 },
    "Project details:": { de: "Projektdetails:", en: "Project details:", updatedTs: 1651155609098 },
    Projects: { de: "Projekte", en: "Projects", updatedTs: 1651155609098 },
    "Provide gross price": { de: "Gesamtpreis hinzufügen", en: "Provide gross price", updatedTs: 1651155609098 },
    Quantity: { de: "Menge", en: "Quantity", updatedTs: 1651155609098 },
    "Re-submit": { de: "Erneut einreichen", en: "Re-submit", updatedTs: 1651155609098 },
    "Re-upload file": { de: "Datei erneut hochladen", en: "Re-upload file", updatedTs: 1651155609098 },
    "Recent tenders activity": {
        de: "Laufende Ausschreibungen",
        en: "Recent tenders activity",
        updatedTs: 1651155609098
    },
    "Recommended contractor": {
        de: "Vorgeschlagener Unternehmer",
        en: "Recommended contractor",
        updatedTs: 1651155609098
    },
    "Please make sure your business details are filled out before send the offer request": {
        de: "Stelle sicher, dass deine Firmenangaben im Profil vollständig und korrekt sind, bevor du die Offertanfragen versendest.",
        en: "Please make sure your business details are filled out before send the offer request.",
        updatedTs: 1658735871657
    },
    "Please provide the price in input below.": {
        de: "Füge bitte den Gesamtpreis (brutto) ein.",
        en: "Please provide the total price (gross).",
        updatedTs: 1658735877519
    },
    "Please review the documents, and": {
        de: "Bitte prüfe die Dokumente und",
        en: "Please review the documents, and",
        updatedTs: 1658735883950
    },
    Partners: { de: "Hersteller", en: "Producer", updatedTs: 1660807201150 },
    "Refresh the page": { de: "Aktualisiere die Seite", en: "Refresh the page", updatedTs: 1658735901347 },
    Reject: { de: "Ablehnen", en: "Reject", updatedTs: 1651155609098 },
    "Reject changes": { de: "Änderungen ablehnen", en: "Reject changes", updatedTs: 1651155609098 },
    Rejected: { de: "Abgelehnt", en: "Rejected", updatedTs: 1651155609098 },
    Reload: { de: "neu laden", en: "Reload\n", updatedTs: 1651155609098 },
    "Reminders sent": { de: "Erinnerungen gesendet", en: "Reminders sent", updatedTs: 1651155609098 },
    Remove: { de: "Entfernen", en: "Remove", updatedTs: 1651155609098 },
    "Remove contact": { de: "Kontakt entfernen", en: "Remove contact", updatedTs: 1651155609098 },
    "Remove from submitters": {
        de: "Von der Unternehmerliste entfernen",
        en: "Remove from submitters",
        updatedTs: 1651155609098
    },
    "Remove partner": { de: "Partner entfernen", en: "Remove partner", updatedTs: 1651155609098 },
    "Remove template": { de: "Vorlage entfernen", en: "Remove template", updatedTs: 1651155609098 },
    Removed: { de: "Gelöscht", en: "Removed", updatedTs: 1651155609098 },
    Rename: { de: "Umbenennen", en: "Rename", updatedTs: 1651155609098 },
    Reports: { de: "Berichte", en: "Reports", updatedTs: 1651155609098 },
    "Request cancelled $1": { de: "Anfrage zurückgezogen $1", en: "Request cancelled $1", updatedTs: 1651155609098 },
    "Request rejected $1": { de: "Anfrage abgelehnt $1", en: "Request rejected $1", updatedTs: 1651155609098 },
    "Requested $1": { de: "Offerte angefragt $1", en: "Requested $1", updatedTs: 1651155609098 },
    "Round 1 Unit Price": { de: "Angebotsrunde Einheitspreis", en: "Round 1 Unit Price", updatedTs: 1651155609098 },
    "Round 1 Value": { de: "Angebotsrunde Wert", en: "Round 1 Value", updatedTs: 1651155609098 },
    "Round 2": { de: "Abgebotsrunde", en: "Round 2", updatedTs: 1651155609098 },
    "Round 2 Unit Price": { de: "Abgebotsrunde Einheitspreis", en: "Round 2 Unit Price", updatedTs: 1651155609098 },
    "Round 2 Value": { de: "Abgebotsrunde Wert", en: "Round 2 Value", updatedTs: 1651155609098 },
    "Row $1 - Column $2": { de: "Zeile $1 - Spalte $2", en: "Row $1 - Column $2", updatedTs: 1651155609098 },
    "SECTION $1": { de: "ABSCHNITT $1", en: "SECTION $1", updatedTs: 1651155609098 },
    "STEP $1": { de: "SCHRITT $1", en: "STEP $1", updatedTs: 1651155609098 },
    Save: { de: "Speichern", en: "Save", updatedTs: 1651155609098 },
    "Save and close": { de: "Speichern und schliessen", en: "Save and close", updatedTs: 1651155609098 },
    "Save as template": { de: "Als Vorlage speichern ", en: "Save as template", updatedTs: 1651155609098 },
    "Save changes": { de: "Speichern", en: "Save changes", updatedTs: 1651155609098 },
    "Save comments and close": {
        de: "Kommentare speichern und schliessen",
        en: "Save comments and close",
        updatedTs: 1651155609098
    },
    Saved: { de: "Gespeichert", en: "Saved", updatedTs: 1651155609098 },
    Saving: { de: "Speichert...", en: "Saving", updatedTs: 1651155609098 },
    "Search...": { de: "Suche...", en: "Search...", updatedTs: 1651155609098 },
    "Second offer received $1": { de: "Abgebot erhalten", en: "Second offer received", updatedTs: 1651155609098 },
    "Second round": { de: "Abgebotsrunde starten", en: "Second round", updatedTs: 1651155609098 },
    "Section name": { de: "Bezeichnung des Abschnitts", en: "Section name", updatedTs: 1651155609098 },
    Select: { de: "Auswählen", en: "Select", updatedTs: 1651155609098 },
    "Removing this section will also remove all the positions inside.": {
        de: "Wenn du diesen Abschnitt löschst, werden auch die darin aufgeführten Positionen entfernt.",
        en: "Removing this section will also remove all the positions inside.",
        updatedTs: 1658735935289
    },
    "Select date": { de: "Datum auswählen ", en: "Select date", updatedTs: 1651155609098 },
    "Select file": { de: "Datei auswählen", en: "Select file", updatedTs: 1651155609098 },
    "Selected Submitters": { de: "Ausgewählte Unternehmer", en: "Selected Submitters", updatedTs: 1651155609098 },
    "Selected contractors will recieve an email, with the link to the devis, project specification, and an optional message.":
        {
            de: "Eingeladene Unternehmer erhalten eine E-Mail mit einem Link zum Leistungsverzeichnis mit folgenden Zusatzinformationen: Architekturbüro, Kontakt, Telefon, E-Mail, Projekttyp, Projekt, PLZ und Ort, Arbeitsgattung, Arbeitsstart, Arbeitsende, Eingabedatum.",
            en: "Selected contractors will recieve an email, with the link to the work description, project specification, and an optional message.",
            updatedTs: 1651155609098
        },
    "Selected for this project": {
        de: "Für dieses Projekt ausgewählt",
        en: "Selected for this project",
        updatedTs: 1651155609098
    },
    Send: { de: "Senden", en: "Send", updatedTs: 1651155609098 },
    "Send for approval": { de: "Zur Bestätigung senden", en: "Send for approval", updatedTs: 1651155609098 },
    "Send message": { de: "Nachricht senden", en: "Send message", updatedTs: 1651155609098 },
    "Send reminder": { de: "Erinnerung senden", en: "Send reminder", updatedTs: 1651155609098 },
    "Send request for approval": {
        de: "Anfrage zur Bestätigung senden",
        en: "Send request for approval",
        updatedTs: 1651155609098
    },
    Submitters: { de: "Submittenten", en: "Submitters", updatedTs: 1651155609098 },
    "Should be empty": { de: "Sollte leer sein", en: "Should be empty", updatedTs: 1651155609098 },
    "Show 2nd round offer": { de: "Abgebot anzeigen", en: "Show 2nd round offer", updatedTs: 1651155609098 },
    "Show Devis": { de: "Leistungsverzeichnis anzeigen", en: "Show work description", updatedTs: 1651155609098 },
    "Show conditions": { de: "Konditionen anzeigen", en: "Show conditions", updatedTs: 1651155609098 },
    "Show details": { de: "Details anzeigen", en: "Show details", updatedTs: 1651155609098 },
    "Show offer": { de: "Offerte anzeigen", en: "Show offer", updatedTs: 1651155609098 },
    "Show tender": { de: "Ausschreibung anzeigen", en: "\nShow tender", updatedTs: 1651155609098 },
    Sign: { de: "Einheit", en: "Sign", updatedTs: 1651155609098 },
    "Since you submitted a file-based devis, we’re not able to read the price directly from the document.": {
        de: "In einem dateibasierten Leistungsverzeichnis ist es nicht möglich, die Preise automatisch aus dem Dokument zu lesen.",
        en: "Since you submitted a file-based work description, we’re not able to read the price directly from the document.",
        updatedTs: 1651155609098
    },
    "Smart Devis": { de: "Smart Devis", en: "Smart Devis", updatedTs: 1651155609098 },
    "Some contacts cannot be imported due to the email duplication.": {
        de: "Manche Kontakte konnten aufgrund identischer E-Mail-Adressen nicht importiert werden.",
        en: "Some contacts cannot be imported due to the email duplication.",
        updatedTs: 1651155609098
    },
    "Some sections contain no positions; they'll be omitted.": {
        de: "Manche Abschnitte enthalten keine Positionen – diese werden ausgeblendet.",
        en: "Some sections contain no positions; they'll be omitted.",
        updatedTs: 1651155609098
    },
    "Sorry, we're working on it.": {
        de: "Bildschirmgrösse nicht unterstützt.",
        en: "Screen size not supported.",
        updatedTs: 1651155609098
    },
    "Sort by": { de: "Sortieren nach", en: "Sort by", updatedTs: 1651155609098 },
    "Special provisions": { de: "Besondere Bestimmungen", en: "Special provisions", updatedTs: 1651155609098 },
    "Specialist planner": { de: "Fachplaner", en: "Specialist Planner", updatedTs: 1651155609098 },
    "Specialist planner #2": { de: "Fachplaner #2", en: "Specialist planner #2", updatedTs: 1651155609098 },
    "Select files": { de: "Wähle die Dateien", en: "Select files", updatedTs: 1658736934374 },
    "Small screen support is coming soon.": {
        de: "Bitte vergrössere dein Browserfenster, um Smart Devis optimal nutzen zu können.",
        en: "Please increase the size of your browser window to get the most out of Smart Devis.",
        updatedTs: 1658736946923
    },
    "Some fields have not been filled. Please fill them and try again": {
        de: "Manche Felder wurden nicht ausgefüllt. Bitte fülle alle Felder aus und versuche es erneut.",
        en: "Some fields have not been filled. Please fill them and try again.",
        updatedTs: 1658736961963
    },
    "Something went wrong, try again later": {
        de: "Etwas ging schief, versuch es später noch einmal.",
        en: "Something went wrong, try again later",
        updatedTs: 1658736980292
    },
    "Something went wrong uploading the picture. Try again": {
        de: "Beim Hochladen des Bildes ist ein Fehler aufgetreten. Bitte versuch es erneut.",
        en: "Something went wrong uploading the picture. Try again",
        updatedTs: 1658736986037
    },
    "Specialist planner #3": { de: "Fachplaner #3", en: "Specialist planner #3", updatedTs: 1651155609098 },
    "Specialist planner #4": { de: "Fachplaner #4", en: "Specialist planner #4", updatedTs: 1651155609098 },
    "Specialist planner #5": { de: "Fachplaner #5", en: "Specialist planner #5", updatedTs: 1651155609098 },
    Specification: { de: "Leistungsverzeichnis", en: "Work description", updatedTs: 1651155609098 },
    St: { de: "St", en: "pc.", updatedTs: 1651155609098 },
    "Start Second Round": { de: "Abgebotsrunde starten", en: "Start Second Round", updatedTs: 1651155609098 },
    "Start negotiation": { de: "Vergaberunde starten", en: "Start negotiation", updatedTs: 1651155609098 },
    "Start second round": { de: "Abgebotsrunde starten", en: "Start second round", updatedTs: 1651155609098 },
    Status: { de: "Status", en: "Status", updatedTs: 1651155609098 },
    "Sub-total $1": { de: "Zwischensumme $1", en: "Sub-total $1", updatedTs: 1651155609098 },
    Submit: { de: "Senden", en: "Submit", updatedTs: 1651155609098 },
    "Submit 2nd round offer": { de: "Abgebot einreichen", en: "Submit 2nd round offer", updatedTs: 1651155609098 },
    "Submit a gross price": { de: "Gesamtpreis einfügen", en: "Submit a gross price", updatedTs: 1651155609098 },
    "Submitters list": { de: "Submittentenliste", en: "Submitters list", updatedTs: 1651155609098 },
    "Submitters updated": { de: "Submittenten aktualisiert", en: "Submitters updated", updatedTs: 1651155609098 },
    "Submitting offer will be no longer available after rejection.": {
        de: "Das eingereichte Angebot wird nach einer Ablehnung nicht mehr verfügbar sein.",
        en: "Submitting offer will no longer be available after rejection.",
        updatedTs: 1651155609098
    },
    "Subsection $1": { de: "Unterabschnitt $1", en: "Subsection $1", updatedTs: 1651155609098 },
    Subtotal: { de: "Zwischensumme", en: "Subtotal", updatedTs: 1651155609098 },
    Sum: { de: "Betrag", en: "Sum", updatedTs: 1651155609098 },
    "Sum\\n(CHF)": { de: "Betrag\\n(CHF)", en: "Sum\\n(CHF)", updatedTs: 1651155609098 },
    "Supported files": { de: "Unterstützte Dateien", en: "Supported files", updatedTs: 1651155609098 },
    Surname: { de: "Nachname", en: "Surname", updatedTs: 1651155609098 },
    Tax: { de: "MwSt.", en: "Tax", updatedTs: 1651155609098 },
    Template: { de: "Vorlage ", en: "Template", updatedTs: 1651155609098 },
    Templates: { de: "Vorlagen ", en: "Templates", updatedTs: 1651155609098 },
    "Terms of Service": { de: "AGBs", en: "Terms of Service", updatedTs: 1651155609098 },
    Text: { de: "Text", en: "Text", updatedTs: 1651155609098 },
    "Text paragraph": { de: "Text Abschnitt", en: "Text paragraph", updatedTs: 1651155609098 },
    "The email address is already in use by another account.(auth/email-already-exists)": {
        de: "Die E-Mail-Adresse wird bereits von einem anderen Konto verwendet.",
        en: "The email address is already in use by another account.(auth/email-already-exists)",
        updatedTs: 1651155609098
    },
    "The required fields are company name and email.": {
        de: "Die Pflichtfelder sind Firmenname und E-Mail Adresse.",
        en: "The required fields are company name and email.",
        updatedTs: 1651155609098
    },
    "There are no contacts matching your search": {
        de: "Keine passenden Kontakte gefunden",
        en: "There are no contacts matching your search",
        updatedTs: 1651155609098
    },
    "This contact cannot be deleted, it's used in some project": {
        de: "Dieser Kontakt kann nicht gelöscht werden, da er in einem Projekt genutzt wird.",
        en: "This contact cannot be deleted, it's used in some project",
        updatedTs: 1651155609098
    },
    "This contractor is in some offers and cannot be deleted": {
        de: "Dieser Unternehmer ist Teil eines laufenden Prozesses und kann nicht gelöscht werden.",
        en: "This contractor is in some offers and cannot be deleted",
        updatedTs: 1651155609098
    },
    "This initiates finalization. Once prices are accepted by the contractor contract is generated.": {
        de: " ",
        en: " ",
        updatedTs: 1651155609098
    },
    cancel: { de: "Abbrechen", en: "Cancel", updatedTs: 1651155609099 },
    "The second round is a flexible way to adjust the offer.": {
        de: "In der Abgebotsrunde kannst du das Leistungsverzeichnis nochmals anpassen, bevor du es an die ausgewählten Unternehmer übermitteln.",
        en: "The second round is a flexible way to adjust the work description.",
        updatedTs: 1658737008535
    },
    "This position can only be moved to a subsection": {
        de: "Diese Position kann ausschliesslich zu einem Unterabschnitt bewegt werden.",
        en: "This position can only be moved to a subsection",
        updatedTs: 1651155609098
    },
    "This will remove the contractor from all your projects. Proceed?": {
        de: "Dadurch wird der Unternehmer aus allen Projekten entfernt. Fortfahren?",
        en: "This will remove the contractor from all your projects. Proceed?",
        updatedTs: 1651155609098
    },
    Title: { de: "Titel", en: "Title", updatedTs: 1651155609098 },
    "To contract": { de: "Zum Werkvertrag", en: "To contract", updatedTs: 1651155609098 },
    "To import your existing contacts,": {
        de: "Um Ihre vorhandenen Kontakte zu importieren,",
        en: "To import your existing contacts,",
        updatedTs: 1651155609098
    },
    "To submit an offer for:": {
        de: "Um eine Offerte zu diesem LV zu erstellen:",
        en: "To submit an offer for:",
        updatedTs: 1651155609098
    },
    "Total price": { de: "Gesamtpreis", en: "Total price", updatedTs: 1651155609098 },
    Translations: { de: "Übersetzungen", en: "Translations", updatedTs: 1651155609098 },
    Type: { de: "Typ", en: "Type", updatedTs: 1651155609098 },
    "Type to add options": { de: "Beschreibung eingeben", en: "Type to add options", updatedTs: 1651155609098 },
    Unit: { de: "Einheit", en: "Unit", updatedTs: 1651155609098 },
    "Unit price": { de: "Einheitspreis", en: "Unit price", updatedTs: 1651155609098 },
    "Unit price\\n(CHF)": { de: "Einheitspreis\\n(CHF)", en: "Unit price\\n(CHF)", updatedTs: 1651155609098 },
    Unknown: { de: "Unbekannt", en: "Unkown", updatedTs: 1651155609098 },
    Update: { de: "Aktualisieren", en: "Update", updatedTs: 1651155609098 },
    "Update Tender": { de: "Ausschreibung aktualisieren", en: "Update Tender", updatedTs: 1651155609098 },
    "Update to our Policy Privacy and Terms of Service": {
        de: "Aktualisierung unserer Datenschutzrichtlinie und unseren AGBs",
        en: "Update to our Policy Privacy and Terms of Service",
        updatedTs: 1651155609098
    },
    "Updated devis": {
        de: "Aktualisiertes Leistungsverzeichnis",
        en: "Updated work description",
        updatedTs: 1651155609098
    },
    "Updated entry date:": { de: "Aktualisiertes Eingabedatum:", en: "Updated entry date:", updatedTs: 1651155609098 },
    Upload: { de: "Hochladen", en: "Upload", updatedTs: 1651155609098 },
    "Upload file": { de: "Datei hochladen", en: "Upload file", updatedTs: 1651155609099 },
    "Upload filled contacts file": {
        de: "Ausgefüllte Kontaktdatei hochladen",
        en: "Upload filled contacts file",
        updatedTs: 1651155609099
    },
    "Upload logo": { de: "Logo hochladen", en: "Upload logo", updatedTs: 1651155609099 },
    "Uploaded devis": { de: "Angebot des Unternehmers", en: "Uploaded offer", updatedTs: 1651155609099 },
    "Uploaded file": { de: "Hochgeladene Datei", en: "Uploaded file", updatedTs: 1651155609099 },
    Url: { de: "Url", en: "Url", updatedTs: 1651155609099 },
    "Use existing": {
        de: "Freitext-LV aus Vorlage öffnen",
        en: "Use existing work description",
        updatedTs: 1651155609099
    },
    "Use existing devis": {
        de: "LV-Vorlagen durchsuchen",
        en: "Use existing work description",
        updatedTs: 1651155609099
    },
    "Use selected": { de: "Vorlage verwenden", en: "Use selected", updatedTs: 1651155609099 },
    "User info": { de: "Benutzerangaben", en: "User info", updatedTs: 1651155609099 },
    Value: { de: "Wert", en: "Value", updatedTs: 1651155609099 },
    "Value is too short": { de: "Wert ist zu kurz.", en: "Value is too short.", updatedTs: 1651155609099 },
    city: { de: "Ort", en: "City", updatedTs: 1651155609099 },
    "To change devis type, detach current devis first": {
        de: "Entferne das vorhandene Leistungsverzeichnis, um die Art des Leistungsverzeichnis zu ändern.",
        en: "To change work description type, detach current work description first",
        updatedTs: 1658737030736
    },
    "To change round values, open current devis": {
        de: "Öffne das Leistungsverzeichnis, um Positionen zu bearbeiten.",
        en: "To change round values, open current work description",
        updatedTs: 1658737035751
    },
    "Value is too short (6)": {
        de: "Der eingetragene Wert ist zu kurz (min. 6).",
        en: "Value is too short (min. 6).",
        updatedTs: 1651155609099
    },
    "Value must be equal or greater than 0": {
        de: "Wert muss gleich oder größer als 0",
        en: "Value must be equal or greater than 0",
        updatedTs: 1651155609099
    },
    "Value not allowed": { de: "Wert nicht erlaubt.", en: "Value not allowed.", updatedTs: 1651155609099 },
    "Values are not the same": {
        de: "Werte stimmen nicht überein.",
        en: "Values are not the same.",
        updatedTs: 1651155609099
    },
    "Version date": { de: "Versionsdatum", en: "Version date", updatedTs: 1651155609099 },
    "Version:": { de: "Version:", en: "Version:", updatedTs: 1651155609099 },
    "View projects": { de: "Projekte ansehen", en: "View projects", updatedTs: 1651155609099 },
    Warning: { de: "Warnung", en: "Warning", updatedTs: 1651155609099 },
    "Warning: all project data will be lost.": {
        de: "Achtung: Alle Projektdaten gehen verloren.",
        en: "Warning: all project data will be lost.",
        updatedTs: 1651155609099
    },
    "We encountered a problem": {
        de: "Wir sind auf ein Problem gestoßen.",
        en: "We encountered a problem.",
        updatedTs: 1651155609099
    },
    "We track our errors automatically, but if the problem persists,": {
        de: "Wir verfolgen unsere Fehler automatisch, aber wenn das Problem weiter besteht,",
        en: "We track our errors automatically, but if the problem persists,",
        updatedTs: 1651155609099
    },
    "What's new?": { de: "Was gibt's Neues?", en: "What's new?", updatedTs: 1651155609099 },
    Wo: { de: "Wo", en: "Where", updatedTs: 1651155609099 },
    Work: { de: "Arbeiten", en: "Work", updatedTs: 1651155609099 },
    "Work category": { de: "Arbeitsgattung", en: "Work category", updatedTs: 1651155609099 },
    "Work end": { de: "Arbeitsende", en: "Work end", updatedTs: 1651155609099 },
    "Work start": { de: "Arbeitsbeginn", en: "Work start", updatedTs: 1651155609099 },
    "You are about to create a devis template": {
        de: "Neue LV-Vorlage erstellen",
        en: "Create a work description template",
        updatedTs: 1651155609099
    },
    "Waiting for contractor approval": {
        de: "Warte auf die Bestätigung des Unternehmers.",
        en: "Waiting for contractor approval",
        updatedTs: 1658737052443
    },
    "Work with positions and deductions the architect wants you to update.": {
        de: "Die Abgebotsrunde bietet die Möglichkeit, die Offerte anzupassen. Bearbeite die Positionen und Abzüge, die der Architekt markiert hat.",
        en: "Work with positions and deductions the architect wants you to update.",
        updatedTs: 1658737058789
    },
    "Work with positions and deductions you want to be updated by the contractor.": {
        de: "Bearbeite das Leistungsverzeichnis und die Abzüge, die du von den Unternehmern aktualisiert haben möchtest.",
        en: "Work with work description and deductions you want to be updated by the contractor. ",
        updatedTs: 1658737071171
    },
    "You are about to create a demo project": {
        de: "Du bist gerade dabei, ein Projekt aus einer Demovorlage zu erstellen.",
        en: "You are about to create a demo project",
        updatedTs: 1658737086386
    },
    "You are about to cancel the request for offer from:": {
        de: "Du bist gerade dabei, die Anfrage für eine Offerte abzulehnen von:",
        en: "You are about to cancel the request for offer from:",
        updatedTs: 1658737081949
    },
    "You are about to invite selected contractors:": {
        de: "Du bist gerade dabei, die ausgewählten Unternehmer einzuladen:",
        en: "You are about to invite selected contractors:",
        updatedTs: 1658737090246
    },
    "You are about to rename a devis template": {
        de: "Du bist gerade dabei, den Namen der LV-Vorlage zu ändern.",
        en: "You are about to rename a work description template",
        updatedTs: 1658737094721
    },
    "You are about to send contract for approval to:": {
        de: "Du bist gerade dabei, einen Vertrag zur Bestätigung zu senden an:",
        en: "You are about to send contract for approval to",
        updatedTs: 1658737098677
    },
    "You are about to send reminder to selected contractors:": {
        de: "Du bist gerade dabei, eine Erinnerung an die ausgewählten Unternehmer zu senden:",
        en: "You are about to send reminder to selected contractors:",
        updatedTs: 1658737102182
    },
    "You are about to send second round offer to:": {
        de: "Du bist gerade dabei, ein Abgebot einzuholen von:",
        en: "You are about to send second round offer to:",
        updatedTs: 1658737111068
    },
    "You are not allowed to delete the devis after a contractor has been invited.": {
        de: "Du kannst das Leistungsverzeichnis nicht löschen, sobald ein Unternehmer eingeladen wurde.",
        en: "You are not allowed to delete the work description after a contractor has been invited.",
        updatedTs: 1658737118203
    },
    "You are not allowed to edit the devis after a contractor has been invited.": {
        de: "Du kannst das Leistungsverzeichnis nicht bearbeiten, sobald ein Unternehmer eingeladen wurde.",
        en: "You are not allowed to edit the work description after a contractor has been invited.",
        updatedTs: 1658737164386
    },
    "You can edit your account here": {
        de: "Bearbeite hier deinen Account",
        en: "You can edit your account here",
        updatedTs: 1658737173105
    },
    "You can only compare contractors with the same status": {
        de: "Du kannst nur Unternehmer mit dem gleichen Status vergleichen.",
        en: "You can only compare contractors with the same status",
        updatedTs: 1658737186320
    },
    "You have pending offers. This view is now read only": {
        de: "Es ist nicht möglich, ein Leistungsverzeichnis zu bearbeiten, nachdem Unternehmer bereits zur Offerterstellung eingeladen wurden.",
        en: "You have pending offers. This view is now read only.",
        updatedTs: 1651155609099
    },
    "You were not chosen to contract": {
        de: "Ihre Offerte wurde nicht angenommen.",
        en: "You were not chosen to contract",
        updatedTs: 1651155609099
    },
    "You will not be able to edit the devis nor send the contract to other contractors.": {
        de: "Es wird nicht mehr möglich sein, das Leistungsverzeichnis zu bearbeiten oder den Werkvertrag an andere Unternehmer zu senden.",
        en: "You will not be able to edit the work description nor send the contract to other contractors.",
        updatedTs: 1651155609099
    },
    "Your contract with $1 is ready to download": {
        de: "Ihr Vertrag mit $1 steht zum Download bereit.",
        en: "Your contract with $1 is ready to download.",
        updatedTs: 1651155609099
    },
    "Your offer for the second round has been successfully submitted.": {
        de: "Ihr Abgebot wurde erfolgreich übermittelt.",
        en: "Your offer for the second round has been successfully submitted.",
        updatedTs: 1651155609099
    },
    "Your offer has been successfully submitted.": {
        de: "Ihre Offerte wurde erfolgreich übermittelt.",
        en: "Your offer has been successfully submitted.",
        updatedTs: 1651155609099
    },
    "Your offer was not chosen to the second round": {
        de: "Ihre Offerte wurde nicht für die Abgebotsrunde ausgewählt.",
        en: "Your offer was not chosen to the second round.",
        updatedTs: 1651155609099
    },
    "Your user account hasn't been filled with all necessary data": {
        de: "Ihre notwendigen Kontoinformationen sind unvollständig.",
        en: "Your user account hasn't been filled with all necessary data",
        updatedTs: 1651155609099
    },
    "Zip code": { de: "PLZ", en: "Zip Code", updatedTs: 1651155609099 },
    and: { de: "und", en: "and", updatedTs: 1651155609099 },
    applied: { de: "hinzugefügt", en: "applied", updatedTs: 1651155609099 },
    "You can start the second round only with contractors with the same status": {
        de: "Du kannst nur mit Unternehmern mit dem gleichen Status die Abgebotsrunde starten.",
        en: "You can start the second round only with contractors with the same status",
        updatedTs: 1658737199741
    },
    "You don't have sufficient permissions to view this page": {
        de: "Du hast leider keine Berechtigung zum Anzeigen dieser Seite.",
        en: "You don't have sufficient permissions to view this page.",
        updatedTs: 1658737243506
    },
    'You have accepted the invitation. Click on "Open Devis" to enter your conditions.': {
        de: "Du hast die Einladung angenommen. Klicke auf “Ausschreibung öffnen”, um deine Konditionen einzugeben.",
        en: 'You have accepted the invitation. Click on "Open Tender" to enter your conditions.',
        updatedTs: 1658737259441
    },
    "You have declined the invitation to submit an offer.": {
        de: "Du hast die Einladung zur Abgabe einer Offerte abgelehnt.",
        en: "You have declined the invitation to submit an offer.",
        updatedTs: 1658737267430
    },
    "You have unsaved items. If you leave, the data will be lost": {
        de: "Du hast noch nicht gespeicherte Einträge. Wenn du diese Seite verlässt, gehen deine Daten verloren.",
        en: "You have unsaved items. If you leave, the data will be lost.",
        updatedTs: 1658737302538
    },
    "You have submitted the offer. This view is now read only": {
        de: "Du hast das Angebot eingereicht. Diese Ansicht ist jetzt schreibgeschützt.",
        en: "You have submitted the offer. This view is now read only.",
        updatedTs: 1658737280874
    },
    "You're about to accept an offer for:": {
        de: "Du bist gerade dabei, eine Offerte zu akzeptieren für:",
        en: "You're about to accept an offer for:",
        updatedTs: 1658737321301
    },
    "You're about to create contract with": {
        de: "Du bist gerade dabei, einen Werkvertrag zu erstellen mit:",
        en: "You're about to create contract with",
        updatedTs: 1658737323783
    },
    "You're about to submit an offer for:": {
        de: "Du bist gerade dabei, eine Offerte einzureichen an:",
        en: "You're about to submit an offer for:",
        updatedTs: 1658737327189
    },
    "You're about to submit second round offer for:": {
        de: "Du bist gerade dabei, ein Angebot einzureichen an:",
        en: "You're about to submit second round offer for:",
        updatedTs: 1658737330435
    },
    "Your are about to start a second round with selected contractors:": {
        de: "Du bist gerade dabei, eine Abgebotsrunde mit den ausgewählten Unternehmern zu beginnen:",
        en: "You're about to start a second round with selected contractors:",
        updatedTs: 1658737334258
    },
    "Your are about to start final round with:": {
        de: "Du bist gerade dabei, eine Vergaberunde zu starten mit:",
        en: "You're about to start final round with:",
        updatedTs: 1658737343525
    },
    "Your offer will be placed here. Click 'Upload file' button to upload an offer.": {
        de: 'Deine Offerte wird hier platziert. Wähle "Datei hochladen", um eine Offerte hochzuladen.',
        en: "Your offer will be placed here. Click 'Upload file' button to upload an offer.",
        updatedTs: 1658737353828
    },
    "contacts-template": { de: "Kontaktimport-Vorlage", en: "contacts-template", updatedTs: 1651155609099 },
    "contractors responded": {
        de: "Unternehmer haben geantwortet.",
        en: "contractors responded",
        updatedTs: 1651155609099
    },
    "contractors responded to second round": {
        de: "Unternehmer haben Abgebote eingereicht.",
        en: "Contractors responded to second round",
        updatedTs: 1651155609099
    },
    d: { de: "d", en: "d", updatedTs: 1651155609099 },
    description: { de: "Beschreibung", en: "Description", updatedTs: 1651155609099 },
    "e.g missing information": {
        de: "z.B. fehlende Informationen",
        en: "e.g. missing information",
        updatedTs: 1651155609099
    },
    gl: { de: "gl", en: "gl", updatedTs: 1651155609099 },
    h: { de: "h", en: "h", updatedTs: 1651155609099 },
    hl: { de: "hl", en: "hl", updatedTs: 1651155609099 },
    in: { de: "in", en: "in", updatedTs: 1651155609099 },
    kJ: { de: "kJ", en: "kJ", updatedTs: 1651155609099 },
    kg: { de: "kg", en: "kg", updatedTs: 1651155609099 },
    l: { de: "l", en: "l", updatedTs: 1651155609099 },
    m: { de: "m", en: "m", updatedTs: 1651155609099 },
    more: { de: "Mehr", en: "more", updatedTs: 1651155609099 },
    "m²": { de: "m²", en: "m²", updatedTs: 1651155609099 },
    "m³": { de: "m³", en: "m³", updatedTs: 1651155609099 },
    negative: { de: "Minus", en: "negative", updatedTs: 1651155609099 },
    new: { de: "Neubau", en: "New", updatedTs: 1651155609099 },
    number: { de: "Betrag", en: "amount", updatedTs: 1651155609099 },
    of: { de: "von", en: "of", updatedTs: 1651155609099 },
    percent: { de: "Prozent", en: "percent", updatedTs: 1651155609099 },
    pl: { de: "pl", en: "pl", updatedTs: 1651155609099 },
    positive: { de: "Plus", en: "positive", updatedTs: 1651155609099 },
    renovation: { de: "Umbau", en: "Renovation", updatedTs: 1651155609099 },
    restoration: { de: "Sanierung", en: "Restoration", updatedTs: 1651155609099 },
    t: { de: "t", en: "t", updatedTs: 1651155609099 },
    "those not selected to the second round are being rejected from the offering.": {
        de: " ",
        en: " ",
        updatedTs: 1651155609099
    },
    "email us": { de: "Schicke uns eine E-Mail", en: "email us", updatedTs: 1658737373610 },
    "feel free to contact our customer support.": {
        de: "Wende dich gerne an unseren Kundensupport.",
        en: "Feel free to contact our customer support.",
        updatedTs: 1658737384189
    },
    "if you have any questions.": {
        de: "Wenn du Fragen hast.",
        en: "if you have any questions.",
        updatedTs: 1658737392894
    },
    "{Cancel adding/editing contractor}Cancel": {
        de: "{Cancel adding/editing contractor}Abbrechen",
        en: "{Cancel adding/editing contractor}Cancel",
        updatedTs: 1651155609099
    },
    "{Email subject}Accept changes": {
        de: "{Email subject}Smart Devis: Vergabe akzeptieren",
        en: "{Email subject}Smart Devis: Accept changes",
        updatedTs: 1651155609099
    },
    "{Email subject}Contract created": {
        de: "{Email subject}Smart Devis: Vertrag erstellt",
        en: "{Email subject}Smart Devis: Contract created",
        updatedTs: 1651155609099
    },
    "{Email subject}Contract proposal rejected": {
        de: "{Email subject}Smart Devis: Vertragsvorschlag abgelehnt",
        en: "{Email subject}Smart Devis: Contract proposal rejected",
        updatedTs: 1651155609099
    },
    "{Email subject}New registration": {
        de: "{Email subject}Smart Devis: Neue Registrierung",
        en: "{Email subject}Smart Devis: New registration",
        updatedTs: 1651155609099
    },
    "{Email subject}Offer accepted": {
        de: "{Email subject}Smart Devis: Offerte angenommen",
        en: "{Email subject}Smart Devis: Offer accepted",
        updatedTs: 1651155609099
    },
    "{Email subject}Offer from": {
        de: "{Email subject}Smart Devis: Offerte von",
        en: "{Email subject}Smart Devis: Offer from",
        updatedTs: 1651155609099
    },
    "{Email subject}Offer rejected": {
        de: "{Email subject}Offerte abgelehnt",
        en: "{Email subject}Offer rejected",
        updatedTs: 1651155609099
    },
    "{Email subject}Offer reminder": {
        de: "{Email subject}Smart Devis: Erinnerung",
        en: "{Email subject}Offer reminder",
        updatedTs: 1651155609099
    },
    "{Email subject}Offer request": {
        de: "{Email subject}Smart Devis: Anfrage für eine Offerte",
        en: "{Email subject}Smart Devis: Offer request",
        updatedTs: 1651155609099
    },
    "{Email subject}Request canceled": {
        de: "{Email subject}Smart Devis: Anfrage zurückgezogen",
        en: "{Email subject}Smart Devis: Request canceled",
        updatedTs: 1651155609099
    },
    "{Email subject}Second round offer request": {
        de: "{Email subject}Smart Devis: Anfrage für ein Abgebot",
        en: "{Email subject}Smart Devis: Second round offer request",
        updatedTs: 1651155609099
    },
    "{Email subject}Smart Devis: Email address has changed": {
        de: "{Email subject}Smart Devis: E-Mail-Adresse geändert",
        en: "{Email subject}Smart Devis: Email address has changed",
        updatedTs: 1651155609099
    },
    "{Email subject}Smart Devis: Reset password": {
        de: "{Email subject}Smart Devis: Passwort zurücksetzen",
        en: "{Email subject}Smart Devis: Reset password",
        updatedTs: 1651155609099
    },
    "{Email subject}has rejected to provide an offer": {
        de: "{Email subject}Smart Devis: hat abgelehnt",
        en: "{Email subject}Smart Devis: has rejected to provide an offer",
        updatedTs: 1651155609099
    },
    "{Number}No": { de: "{Number}Nr.", en: "{Number}No", updatedTs: 1651155609099 },
    "{TAG}ADDED": { de: "{TAG}HINZUGEFÜGT", en: "{TAG}ADDED", updatedTs: 1651155609099 },
    "{TAG}EDITED": { de: "{TAG}BEARBEITET", en: "{TAG}EDITED", updatedTs: 1651155609099 },
    "{TAG}REMOVED": { de: "{TAG}GELÖSCHT", en: "{TAG}REMOVED", updatedTs: 1651155609099 },
    "{a of company b}$1 of $2": { de: "$1 von $2", en: "$1 of $2", updatedTs: 1651155609099 },
    "{alt}Before the contract is created, the contractor must approve the final version.": {
        de: "{alt}Bevor der Werkvertrag erstellt wird, muss der Unternehmer die finale Version bestätigen.",
        en: "{alt}Before the contract is created, the contractor must approve the final version.",
        updatedTs: 1651155609099
    },
    "{contract doc}Contract amount": {
        de: "{contract doc}Vertragssumme",
        en: "{contract doc}Contract price",
        updatedTs: 1651155609099
    },
    "{page x} of $1": { de: "{page x} von $1", en: "{page x} of $1", updatedTs: 1651155609099 },
    "{second round submit} Once the offer is updated you won’t be able to change the prices.": {
        de: "{second round submit}Sobald das Abgebot eingereicht ist, können die Preise nicht mehr geändert werden.",
        en: "{second round submit} Once the offer is updated you won’t be able to change the prices.",
        updatedTs: 1651155609099
    },
    "Import devis": { de: "Externes Leistungsverzeichnis", en: "Import work description", updatedTs: 1652089042678 },
    "Upload devis": { de: "Externes Leistungsverzeichnis", en: "Upload work description", updatedTs: 1652089044652 },
    Street: { de: "Strasse", en: "Street", updatedTs: 1655382817935 },
    "Company Name 2": { de: "Firma", en: "Company Name", updatedTs: 1655383048874 },
    "Company name line 2": { de: "Zusatzinformationen, z.B. Abteilung", en: "Company Name", updatedTs: 1655383054603 },
    "Copy from client": {
        de: "Adresse von Bauherrschaft einfügen",
        en: "Insert address of client",
        updatedTs: 1655383186137
    },
    Cantons: { de: "Kantone (aktiv in...)", en: "Cantons", updatedTs: 1658735077482 },
    "Authentication failed, please try again": {
        de: "Authentifizierung fehlgeschlagen. Bitte versuche es erneut.",
        en: "Authentication failed, please try again",
        updatedTs: 1658735098613
    },
    "Are you sure you want to import all valid contacts available below?": {
        de: "Bist du sicher, dass du alle untenstehenden gültigen Kontakte importieren möchtest?",
        en: "Are you sure you want to import all valid contacts available below?",
        updatedTs: 1658735529305
    },
    "At Smart Devis, we believe in protecting your privacy. As we continue to improve our product and features, we've also revised our":
        {
            de: "Bei Smart Devis glauben wir an den Schutz der Privatsphäre. Während wir unser Produkt und unsere Funktionen weiter verbessern, aktualisieren wir auch unsere",
            en: "At Smart Devis, we believe in protecting your privacy. As we continue to improve our product and features, we've also revised our",
            updatedTs: 1658735566517
        },
    "Company Details are missing. Please fill profile info": {
        de: "Deine Firmendetails sind unvollständig. Bitte fülle die Profilangaben aus.",
        en: "Company Details are missing. Please fill profile info.",
        updatedTs: 1658735594781
    },
    "We will be back in less than 1 hour. Sorry for the inconvenience.": {
        de: "Wir sind spätestens in einer Stunde zurück. Entschuldige die Umstände.",
        en: "We will be back in less than 1 hour. Sorry for the inconvenience.",
        updatedTs: 1658734522971
    },
    "We are under maintenance": {
        de: "Wir befinden uns in der Wartung.",
        en: "We are under maintenance",
        updatedTs: 1658734545180
    },
    "Please select canton": {
        de: "Bitte wähle die Kantone, in denen du aktiv bist.",
        en: "Please select canton",
        updatedTs: 1658734569517
    },
    "Please add your work categories": {
        de: "Bitte wähle die Arbeitsgattungen, die auf dein Leistungsangebot zutreffen.",
        en: "Please add your work categories",
        updatedTs: 1658734596331
    },
    '$1 has sent you the final contract proposal. Click on "Check contract proposal" to accept the contract.': {
        de: "$1 hat dir den endgültigen Vertragsvorschlag geschickt. Klicke auf “Vertragsvorschlag prüfen”, um die Vergabe zu akzeptieren.",
        en: '$1 has sent you the final contract proposal. Click on "Check contract proposal" to accept the contract.',
        updatedTs: 1658735115480
    },
    "Manage credentials": { de: "Zugangsdaten verwalten", en: "Manage credentials", updatedTs: 1658734902424 },
    "Complete your data to be able to use Smart Devis without restrictions.": {
        de: "Vervollständigen Sie Ihre Daten, um Smart Devis ohne Einschränkungen nutzen zu können.",
        en: "Complete your data to be able to use Smart Devis without restrictions.",
        updatedTs: 1666267058955
    },
    "Complete the creation of your account": {
        de: "Vervollständigen Sie die Erstellung Ihres Kontos",
        en: "Complete the creation of your account",
        updatedTs: 1666354377900
    },
    Impersonation: { de: "Impersonation", en: "Impersonation", updatedTs: 1658734922514 },
    "Identity admin console": { de: "Identity admin console", en: "Identity admin console", updatedTs: 1658734932181 },
    "Are you sure you want to create copy of that project?": {
        de: "Bist du sicher, dass du eine Kopie dieses Projekts erstellen möchtest?",
        en: "Are you sure you want to create copy of that project?",
        updatedTs: 1658735170594
    },
    "Create a new devis from free text positions. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.":
        {
            de: "Erstelle ein neues Leistungsverzeichnis aus Freitextpositionen. Der Unternehmer füllt das Angebot in der App aus. Dank des standardisierten Formats, kannst du die Angebote der Unternehmer Punkt für Punkt vergleichen.",
            en: "Create a new devis from free text positions. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.",
            updatedTs: 1658735635235
        },
    "Drop your contacts file here": {
        de: "Lege die Kontaktdatei hier ab",
        en: "Drop your contacts file here",
        updatedTs: 1658735660171
    },
    "If you cancel this offer, you will not be able to invite this contractor again. Instead, you can start the second round in order to request a better offer.":
        {
            de: "Wenn du diese Offertanfrage löschst, kannst du den Unternehmer nicht mehr einladen. Stattdessen kannst du die Abgebotsrunde starten um eine bessere Offerte zu erhalten.",
            en: "If you cancel this offer, you will not be able to invite this contractor again. Instead, you can start the second round in order to request a better offer.\n",
            updatedTs: 1658735707780
        },
    "Make your Devis available to the contractor in your own format. The contractor downloads this, creates his offer and uploads the offer. The contractor enters the total price and the discounts in Smart Devis to enable you to compare the contractors on the platform.":
        {
            de: "Stelle dein Leistungsverzeichnis im eigenen Format dem Unternehmer zu Verfügung. Der Unternehmer lädt dieses herunter, erstellt die Offerte und lädt diese wieder hoch. Der Unternehmer trägt den Gesamtpreis und die Rabatte in Smart Devis ein, um dir den Vergleich der Unternehmer auf der Plattform zu ermöglichen.",
            en: "Make your work description available to the contractor in your own format. The contractor downloads this, creates his offer and uploads the offer. The contractor enters the total price and the discounts in Smart Devis to enable you to compare the contractors on the platform.\n",
            updatedTs: 1658735809394
        },
    "Please check your uploaded file and try again.": {
        de: "Überprüfe die hochgeladene Datei und versuche es erneut.",
        en: "Please check your uploaded file and try again.",
        updatedTs: 1658735852309
    },
    "Reject changes and allow architect to adjust the offer one more time": {
        de: "Lehne die Änderungen ab und erlaube dem Architekten, die Offerte ein weiteres Mal anzupassen.",
        en: "Reject changes and allow architect to adjust the offer one more time",
        updatedTs: 1658735925973
    },
    "Create a new devis from one of your templates. The devis in the project and the template can be edited independently of each other. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.":
        {
            de: "Erstelle ein neues Leistungsverzeichnis aus deinen Vorlagen. Das Leistungsverzeichnis im Projekt und die Vorlage sind unabhängig voneinander editierbar. Der Unternehmer füllt die Offerte direkt in der Anwendung aus. Du kannst die Offerten dank des einheitlichen Formats Punkt für Punkt vergleichen.",
            en: "Create a new work description from one of your templates. The devis in the project and the template can be edited independently of each other. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.",
            updatedTs: 1658735654010
        },
    "Drop your devis file here": {
        de: "Platziere hier dein Leistungsverzeichnis.",
        en: "Drop your work description file here",
        updatedTs: 1658735671231
    },
    "If you don't want to copy values (prices / amount) you can check clear value": {
        de: "Hier kannst du entscheiden, ob du die Werte auch kopieren möchtest.",
        en: "Now you can choose, if you also want to copy the values (prices / amounts)",
        updatedTs: 1658735721025
    },
    "Make your Devis available to the contractor in CRBx or .01s format. The contractor downloads this, fills it out and uploads the offer again in CRBx or .01s format. The contractor enters the total price and the discounts to enable you to compare the contractors on the platform.":
        {
            de: "Stelle dein Leistungsverzeichnis im CRBx oder .01s Format dem Unternehmer zu Verfügung. Der Unternehmer lädt dieses herunter, füllt es aus und lädt die Offerte wieder im Format CRBx oder .01s hoch. Der Unternehmer trägt den Gesamtpreis und die Rabatte in Smart Devis ein, um dir den Vergleich der Unternehmer auf der Plattform zu ermöglichen.",
            en: "Make your work description available to the contractor in CRBx or .01s format. The contractor downloads this, fills it out and uploads the offer again in CRBx or .01s format. The contractor enters the total price and the discounts to enable you to compare the contractors on the platform.\n",
            updatedTs: 1658735789821
        },
    "Please check that you've put correct data": {
        de: "Bitte prüfe, ob alle Daten korrekt sind.",
        en: "Please check that you've put correct data",
        updatedTs: 1658735839664
    },
    "Select contractor you want to highlight in the document as a preferable to work with:": {
        de: "Wähle den Unternehmer, den du markieren möchtest als ",
        en: "Select contractor you want to highlight in the document as a preferable to work with:",
        updatedTs: 1658736914691
    },
    "Thanks to the support of ConReal Swiss AG and these partner companies, the use of Smart Devis is free of charge for you.":
        {
            de: "Die Nutzung von Smart Devis ist für dich dank der Unterstützung der ConReal Swiss AG und dieser Partnerfirmen kostenlos.",
            en: "Thanks to the support of ConReal Swiss AG and these partner companies, the use of Smart Devis is free of charge for you.",
            updatedTs: 1658736997851
        },
    "This project exists for demonstrating how a project works.": {
        de: "Diese Demovorlage dient als Beispiel eines Projekts auf Smart Devis, um zu zeigen, wie der Prozess funktioniert. Dies ist kein reales Projekt und enthält keine realen Daten. Du kannst es nutzen, um die Funktionen der App zu testen oder um dein eigenes Projekt auf dieser Grundlage aufzubauen.",
        en: "This project exists for demonstrating how a project works.",
        updatedTs: 1658737024109
    },
    "Wait for the client to make a finall call": {
        de: "Warte auf die Bestätigung des Unternehmers.",
        en: "Wait for the client to make a final call.",
        updatedTs: 1658737048208
    },
    "You can start the negotiation round only with contractors with the same status": {
        de: "Du kannst nur mit Unternehmern mit dem gleichen Status die Vergabeverhandlung starten.",
        en: "You can start the negotiation round only with contractors with the same status",
        updatedTs: 1658737193831
    },
    "You cannot be logged in as an architect": {
        de: "Du bist jetzt als Architekt angemeldet. Solltest du Unternehmer sein, ist es möglich, dass du ein falsches Konto angelegt haben. In diesem Fall wende dich an uns unter: hello@smartdevis.ch",
        en: "You are now registered as an architect. If you are a contractor, it is possible that you have created a wrong account. In this case please contact us at: hello@smartdevis.ch",
        updatedTs: 1658737234899
    },
    "download and fill out the contacts template (.csv format) available below.": {
        de: "Lade die Vorlage herunter (.csv Format) und füge deine Kontakte ein.",
        en: "download and fill out the contacts template (.csv format) available below.",
        updatedTs: 1658737367175
    },
    "{Email subject}Smart Devis: Verify your e-mail address": {
        de: "{Email subject}Smart Devis: Bestätige deine E-Mail Adresse",
        en: "{Email subject}Smart Devis: Verify your email address",
        updatedTs: 1658737406885
    },
    "{offer submit} Once an offer is submitted you won’t be able to change the prices.": {
        de: "Sobald du die Offerte eingereicht hast, kannst du die Preise nicht mehr ändern.",
        en: "{offer submit} Once an offer is submitted you won’t be able to change the prices.",
        updatedTs: 1658737420424
    },
    "Offers tab will be accessible after picking at least one submitter and providing positions and deductions": {
        de: 'Die Registerkarte "Submission" wird zugänglich, nachdem Sie mindestens einen Einreicher ausgewählt und Positionen und Abzüge angegeben haben',
        en: "Offers tab will be accessible after picking at least one submitter and providing positions and deductions\n",
        updatedTs: 1666254433970
    }
}
